/**
 * ARENA PVE — TẦNG HIỂN THỊ CỦA SÂN 2 CHIỀU TỰ DO (SÔNG + 2 CẦU, KHÔNG CÒN 3 LAND).
 *
 * ⚠️⚠️ TRÙNG TÊN — ĐỌC TRƯỚC KHI SỬA BẤT CỨ GÌ.
 * Repo ĐÃ có `src/render/arena.ts` (`ArenaView`) + `src/render/arena-art.ts`: đó là SÂN ĐẤU 10-WAVE
 * HIỆN TẠI (1000×600, màn DỌC, 1 Nhà, 1 làn). Người dùng đã nhấn mạnh: **Arena là chế độ BỔ SUNG,
 * KHÔNG thay thế game hiện tại.** File NÀY là thế giới Arena PVE (1000×600, NGANG, 2 Nhà, sông dọc
 * chia 2 bờ + 2 cầu) và KHÔNG được import, sửa, hay thay thế 2 file kia. Tên khác hẳn
 * (`arena-battle` vs `arena`) là cố ý.
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * QUYẾT ĐỊNH LỚN CỦA FILE NÀY — MỖI CÁI ĐỀU LÀ MỘT BẪY NẾU LÀM KIỂU KHÁC
 * ════════════════════════════════════════════════════════════════════════════════════════════
 *
 * 0. **XOÁ 3 LAND (refactor "xoá 3 land")**: bản cũ vẽ 3 DẢI NGANG + 2 Nhà cao chạm cả 3 dải + nhãn
 *    land, vì luật cũ KHOÁ mọi unit vào land của nó. Luật nay là không gian 2 CHIỀU TỰ DO, chia bởi
 *    SÔNG dọc + 2 CẦU (xem `src/sim/arena/river.ts`). Vì vậy mọi thứ thuộc "3 land" đã bị XOÁ khỏi
 *    file này: dải màu land, đường kẻ phân land, nhãn land, vạch chia đôi sân ở giữa (giờ chính là
 *    SÔNG), và `arenaLandOptions()`.
 *
 * 1. ĐƠN VỊ VẼ — DÙNG LẠI `UnitViews`, KHÔNG VIẾT LẠI (~25 KB code + hệ xương + art AI).
 *    `UnitViews.sync(dt, world)` đọc 25 trường của `Unit`. `ArenaUnit` CỐ Ý mang đủ 25 trường đó
 *    với `team: 'hero' | 'enemy'` (xem chú thích dài trong `sim/arena/types.ts` về lần SỬA HỢP ĐỒNG
 *    này) ⇒ chỉ cần một ADAPTER, xem `ArenaUnitViewsAdapter` trong `arena-camera.ts`.
 *    TUYỆT ĐỐI không sửa `unitview.ts` và không viết lại lớp vẽ nhân vật ở đây.
 *
 * 2. MÁU 2 NHÀ VẼ NGAY TẠI NHÀ — QUẠT MÁU (PIE) TRÊN ELLIPSE BỆ ĐÁ DƯỚI CHÂN NHÀ (`drawCores`).
 *    ⚠️ LUẬT ĐÃ ĐỔI THEO YÊU CẦU NGƯỜI DÙNG (task-11): *"Thanh máu đổi thành để ở circle nhà để thể
 *    hiện máu còn lại, chứng dừng để ở top."* Bản cũ dán 2 thanh máu vào MÉP TRÊN màn hình
 *    (`setScrollFactor(0)`) vì thế giới cũ rộng 2400 nên một Nhà luôn ngoài tầm nhìn. Nay sân rộng
 *    ĐÚNG MỘT MÀN (1000 = viewW ⇒ `maxScrollX = 0`, xem `tests/arena-render.test.ts`) nên CẢ HAI Nhà
 *    luôn hiện trên màn hình — thanh ở đỉnh vừa thừa vừa ngược yêu cầu, và nó còn bị vẽ HAI LẦN
 *    (bản Phaser này + 2 chip DOM `.arena-core`).
 *
 * 3. ART THIẾU (404) KHÔNG BAO GIỜ LÀM VỠ GAME — hợp đồng bất di bất dịch của repo.
 *    Học đúng cách ở `battlefield-art.ts`: `new Image()` + `onerror → null` + `textures.addCanvas`, và
 *    **KHÔNG dùng `scene.load`**. Mọi đường vẽ ảnh đều có nhánh lùi về bản vẽ code (`drawWorld`).
 *
 * 4. HÌNH HỌC CAMERA NẰM Ở `arena-camera.ts` (hàm thuần, test được không cần Phaser).
 *    File này CHỈ gọi `ArenaCamera`. Đừng tự tính `scrollX` ở đây.
 *
 * ⚠️⚠️ BÀI HỌC QUÁ TRÌNH — ĐỌC KỸ, ĐÃ XẢY RA THẬT Ở CHÍNH FILE NÀY:
 * Một lệnh refactor đã XOÁ NHẦM toàn bộ class `ArenaBattleView` khỏi file này, để lại 140 dòng chỉ
 * có import + `export ... from`. Khi đó:
 *   · `npm test` VẪN XANH (bộ test chỉ chạm hàm thuần ở `arena-camera.ts`),
 *   · `tsc --noEmit` VẪN **0 LỖI** (file rỗng ruột thì không có gì để lỗi),
 *   · `npx vitest run tests/arena-render.test.ts` VẪN 50/50 XANH.
 * ⇒ **TEST XANH + TYPECHECK SẠCH KHÔNG CHỨNG MINH ĐƯỢC DELIVERABLE CÓ TỒN TẠI.**
 * Với file lớn, PHẢI kiểm CẤU TRÚC: `grep -c "class ArenaBattleView"` phải ≥ 1, và `wc -l` phải
 * tương xứng với khối lượng công việc. `tests/arena-render.test.ts` vì thế có bài khoá SỰ TỒN TẠI
 * của class này (đọc file dạng chuỗi) chứ không chỉ test hàm thuần.
 */
import Phaser from 'phaser';
import {
  ARENA_BRIDGE_HALF,
  ARENA_BRIDGES,
  ARENA_CORE,
  ARENA_CORE_BODY_RADIUS,
  ARENA_CORE_DRAW_R,
  ARENA_CORE_Y,
  ARENA_ECON,
  ARENA_RIVER,
  ARENA_TICK,
  ARENA_WORLD,
  type ArenaSide,
  type ArenaUnit,
  arenaDist,
  type ArenaWorld,
} from '../sim/arena/world';
import { ARENA_TEXT } from '../data/arena';
import { sideOfTeam } from '../sim/arena/types';
import { t } from '../i18n';
import { ARENA_CAMERA_VIEW, ArenaCamera, type CameraScene, houseArtFlipX } from './arena-camera';
import { loadBattlefieldArt, coverCrop, type BattlefieldArt } from './battlefield-art';
/*
 * HÌNH ĐẠN DÙNG CHUNG VỚI CHẾ ĐỘ ĐI ẢI — người dùng: *"Trong chế độ chơi arena, hình đường đạn đổi
 * thành hình giống trong chế độ đi ải"*. `resolveShotSkin` là đường phân giải DUY NHẤT (xem chú thích
 * ở `projectiles.ts`): đạn Arena và đạn 10-wave không thể lệch hình vì cùng một bảng `SHAPES`.
 */
import { ensureProjectileTextures, resolveShotSkin } from './projectiles';

// ════════════════════════════════════════════════════════════════════════════
// 1. BẢNG MÀU — MỘT CHỖ, ĐỂ 2 PHE VÀ ĐỊA HÌNH LUÔN ĐỌC RA KHÁC NHAU
// ════════════════════════════════════════════════════════════════════════════

/**
 * MÀU THEO PHE. Người chơi = XANH, địch = ĐỎ: quy ước của TOÀN BỘ game (xem `unitview` tô tướng/
 * quái) nên Arena phải theo, không được "sáng tạo" màu phe riêng.
 *
 * ⚠️ Kèm `deep` (nền đậm) và `edge` (viền): dùng MỘT màu cho cả nền lẫn viền thì hai nửa sân đọc ra
 * y hệt nhau — đúng lỗi "không biết đâu là đất mình".
 */
const SIDE_COLOR: Record<ArenaSide, { base: number; deep: number; edge: number }> = {
  left: { base: 0x1d4ed8, deep: 0x172554, edge: 0x60a5fa },
  right: { base: 0xb91c1c, deep: 0x450a0a, edge: 0xf87171 },
};

/**
 * MÀU NƯỚC / CẦU — CHỈ DÙNG KHI CHƯA CÓ ẢNH (`arena-river.png`) HOẶC LÀM LỚP PHỦ RẤT MỜ.
 *
 * ⚠️ VÌ SAO VẪN PHẢI VẼ ĐƯỢC SÔNG/ CẦU BẰNG CODE: hợp đồng của repo là "thiếu ảnh thì sân vẫn phải
 * chơi được". Nếu bản vẽ code không có sông/ cầu thì khi ảnh 404, người chơi thấy một sân phẳng còn
 * `sim` thì CHẶN ở dòng sông ⇒ quân "đứng im giữa sân" mà không có gì giải thích. Bản vẽ code vì
 * thế phải phản chiếu ĐÚNG hình học của `sim/arena/river.ts` (đọc hằng số, KHÔNG chép số).
 */
const WATER_COLOR = 0x1e3a45;
const WATER_EDGE = 0x2c5560;
const BRIDGE_COLOR = 0x5a4636;
const BRIDGE_EDGE = 0x8a6b4f;

/**
 * MIẾNG PIE MÁU NHÀ — VẼ TRÊN **ELLIPSE BỆ ĐÁ DƯỚI CHÂN NHÀ**, PHÍA SAU NHÀ.
 *
 * ⚠️⚠️ NGƯỜI DÙNG CHỐT HÌNH THỨC (đọc trước khi "sáng tạo" lại): *"Circle kiểu pie ý, fill vừa bằng cái
 * bóng và behind nhà."* Nghĩa chính xác:
 *   · **PIE** = hình QUẠT ĐẶC quét từ TÂM ra (như miếng bánh) — KHÔNG phải vòng rìa, KHÔNG phải cung mảnh;
 *   · **vừa bằng cái bóng** = ĐÚNG cỡ/ ĐÚNG hình dạng ellipse bệ đá `fillEllipse(x, cy + 0,9R, 3,4R, 0,95R)`
 *     mà `drawCores` vẫn vẽ ⇒ dùng CHUNG 3 hằng số dưới đây, KHÔNG thu nhỏ (bản `ring` trước đó thu nhỏ
 *     cho vừa màn hình là SAI yêu cầu — đã bỏ);
 *   · **behind nhà** = quạt phải nằm DƯỚI thân Nhà. Điều đó được bảo đảm bằng THỨ TỰ VẼ trong CÙNG một
 *     `Graphics` (`coreGfx`, depth −95 < ảnh Nhà −94): bệ đá → **quạt** → thân Nhà → vòng "cổng" ⇒ cả
 *     hộp thân Nhà LẪN ảnh Nhà đều đè lên quạt.
 *
 * ⚠️ VÌ SAO KHÔNG CÓ LỚP RIÊNG CHO QUẠT (bài học từ bản trước): muốn quạt nằm TRÊN bệ đá nhưng DƯỚI
 * thân Nhà thì hai đối tượng phải nằm ở hai lớp khác nhau — mà mỗi `Graphics` chỉ có MỘT thứ tự vẽ bên
 * trong nó. Cách duy nhất giữ đúng thứ tự là vẽ TẤT CẢ trong `coreGfx` theo trình tự, và gọi lại MỖI
 * KHUNG HÌNH (`drawCores` rất rẻ: 2 Nhà × ~6 hình).
 *
 * ⚠️ BA HẰNG SỐ NHÀ KHÁC NHAU VÀ KHÔNG ĐƯỢC GỘP (xem khối chú thích dài ở `sim/arena/world.ts`):
 *   · `ARENA_CORE.radius`      (≈24,17) — BÁN KÍNH MỤC TIÊU, tham gia `reach = range + core.radius`
 *                                        ⇒ đụng vào là ĐỔI CÂN BẰNG (đo được: winrate tán xạ 20–63%);
 *   · `ARENA_CORE_BODY_RADIUS` (≈27,5)  — VỎ VA CHẠM (vòng "cổng ra quân" ở tâm Nhà — GIỮ NGUYÊN);
 *   · `ARENA_CORE_DRAW_R`      (≈45,83) — CỠ VẼ (nửa bề rộng box thân Nhà, và bệ đá dưới chân).
 * Quạt máu là HÌNH ẢNH ⇒ suy từ **CỠ VẼ** (`DRAW_R`). Tuyệt đối KHÔNG dùng `ARENA_CORE.radius`.
 */
/** Tâm ellipse bệ đá, tính từ `ARENA_CORE_Y` (đúng công thức `drawCores`: `cy + 0,9R`). */
const CORE_BASE_DY = ARENA_CORE_DRAW_R * 0.9;
/** Nửa trục NGANG của bệ đá (`3,4·R / 2`). */
const CORE_BASE_A = (ARENA_CORE_DRAW_R * 3.4) / 2;
/** Nửa trục DỌC của bệ đá (`0,95·R / 2`). */
const CORE_BASE_B = (ARENA_CORE_DRAW_R * 0.95) / 2;
/**
 * QUY ƯỚC GÓC — DÙNG CHUNG CHO CẢ 2 PHE (để nhìn là so sánh được): quạt LUÔN bắt đầu ở **ĐÁY ellipse**
 * (`+π/2`) và quét THEO CHIỀU KIM ĐỒNG HỒ khi máu còn nhiều. Hệ toạ độ Phaser có `+y` hướng XUỐNG nên
 * TĂNG góc là quay từ `+x` xuống dưới ⇒ đúng chiều kim đồng hồ trên màn hình.
 *
 * ⚠️⚠️ VÌ SAO BẮT ĐẦU Ở ĐÁY, KHÔNG PHẢI Ở ĐỈNH (ĐÃ ĐO BẰNG ẢNH, ĐỔI MỘT LẦN):
 * Bản đầu tôi bắt đầu ở ĐỈNH — và ảnh chụp mức máu 8% cho thấy miếng quạt còn lại nằm ĐÚNG SAU LƯNG NHÀ
 * (đỉnh ellipse bị thân/ mái Nhà che khuất) ⇒ người chơi **gần như không thấy** tín hiệu "Nhà sắp vỡ",
 * tức hỏng đúng lúc tín hiệu quan trọng nhất. Đáy ellipse nằm DƯỚI chân Nhà nên luôn lộ ra.
 * ⇒ Chọn điểm bắt đầu sao cho phần quạt NHỎ NHẤT vẫn nhìn thấy.
 */
const CORE_PIE_START = Math.PI / 2;
/** Số đoạn của cung: `Graphics` không có arc ellipse nên lấy mẫu điểm rồi `fillPoints` (quạt ĐẶC). */
const CORE_PIE_SEGMENTS = 48;

/**
 * NHÃN "SỐ MÁU (+ TÀI NGUYÊN ĐỊCH)" TRÊN ĐẦU NHÀ — màu chữ theo phe và depth.
 *
 * ⚠️ MÀU CHỮ THEO PHE, KHÔNG theo màu Nhà trong ảnh: hai Nhà dùng CÙNG một ảnh art (chỉ lật chiều) nên
 * art không nói được "Nhà nào của ai" — đúng lý do `setTeamMarkers` đã có ở `unitview`. Nhãn máu vì thế
 * lặp lại mã màu phe (xanh = mình, đỏ = địch) để đọc được cả khi ảnh chưa nạp.
 */
const CORE_LABEL_COLOR: Record<ArenaSide, string> = { left: '#bfdbfe', right: '#fecaca' };
/**
 * ⚠️ DEPTH: TRÊN mọi đơn vị (đơn vị ≤ ~6000) để một con lính đi qua không che mất số máu — đây là thông
 * tin SỐNG CÒN của trận; nhưng DƯỚI `SHOT_DEPTH` (7000) để vệt đạn vẫn nằm trên như thiết kế cũ.
 */
const CORE_LABEL_DEPTH = 6500;

/**
 * KẸP TÂM NHÃN THEO BỀ NGANG THẾ GIỚI — Nhà địch ở `x ≈ 935` mà nhãn "Tài nguyên địch 260" có thể rộng
 * hơn 130 đơn vị ⇒ canh giữa đúng tâm Nhà là mép phải nhãn lọt ra ngoài bản đồ (1000) và bị camera cắt.
 * Kẹp theo bề rộng ĐO ĐƯỢC của chính nhãn (`Text.width`) nên không hard-code px nào.
 */
function clampLabelX(x: number, width: number): number {
  const half = Math.max(0, Number.isFinite(width) ? width / 2 : 0);
  const min = half + 4;
  const max = Math.max(min, ARENA_WORLD.w - half - 4);
  return Math.min(Math.max(x, min), max);
}

/**
 * MỘT PHÁT BẮN ĐỂ VẼ **VỆT ĐẠN** — DỮ LIỆU THUẦN CỦA TẦNG HÌNH, KHÔNG PHẢI ENTITY MÔ PHỎNG.
 *
 * ⚠️⚠️ SIM ARENA **CỐ Ý** KHÔNG MÔ PHỎNG ĐẠN BAY (xem chú thích `projectile`/ `dashStrike` trong
 * `sim/arena/world.ts`: *"TRÚNG NGAY mục tiêu (Arena không mô phỏng đạn bay/ dịch chuyển)"*).
 * Yêu cầu người dùng *"Nhân vật, quái đánh xa chưa có đường đạn"* vì thế là **HIỆU ỨNG HÌNH ẢNH**:
 * sát thương vẫn trúng NGAY như cũ, chỉ thêm vệt bay để người chơi HIỂU vì sao địch mất máu.
 * ⚠️ TUYỆT ĐỐI KHÔNG thêm entity đạn vào `sim/` theo hướng làm lệch thời điểm gây sát thương.
 *
 * Hợp đồng với sim (sim-fix phát): `world.drainShots?.(): ArenaShot[]` — mảng mới rồi rỗng hoá, cùng
 * khuôn `drainCastFx`. Vì đây là hợp đồng ĐANG CHỐT, phía scene đọc nó qua interface TUỲ CHỌN
 * (`drainShots?`) nên khi sim chưa phát thì game vẫn chạy y như trước (không vệt đạn).
 */
export interface ArenaShot {
  /** điểm bắn ra (toạ độ THẾ GIỚI) */
  fromX: number;
  fromY: number;
  /** điểm trúng (toạ độ THẾ GIỚI) — sim đã trừ máu ở ĐÚNG thời điểm này */
  toX: number;
  toY: number;
  /** phe bắn — quyết định MÀU VỆT + cỡ chớp ở đầu đích (xanh ta/ đỏ địch) */
  side: ArenaSide;
  /** cỡ đạn (gợi ý độ dày vệt + cỡ chớp) — đơn vị world */
  size: number;
  /**
   * HÌNH VIÊN ĐẠN — do SIM chuyển xuống (xem `ArenaShot` trong `sim/arena/world.ts`), tầng vẽ
   * KHÔNG tự đoán. Người dùng: *"Trong chế độ chơi arena, hình đường đạn đổi thành hình giống trong
   * chế độ đi ải"* ⇒ tầng vẽ tra `skin`/`kind` qua ĐÚNG bảng hình dùng chung với chế độ đi ải
   * (`resolveShotSkin` trong `render/projectiles.ts`).
   *
   * ⚠️ TUỲ CHỌN (`?`) LÀ CỐ Ý: `view.addShots()` còn được công cụ kiểm chứng gọi với dữ liệu TIÊM
   * (không có 2 trường này) — thiếu thì `resolveShotSkin` lùi về hình `thrown`, không được vỡ.
   */
  skin?: string;
  kind?: 'bullet' | 'thrown';
  /**
   * CHIỀU CAO CUNG (đơn vị world) — chỉ để VẼ. Người dùng: *"Nhà chính… ném theo quỹ đạo vòng cung"*.
   * Sim không có trục Z nên độ cao nâng sprite theo `sin(π·k)`, cùng cách chế độ đi ải vẽ chai rượu.
   */
  arcHeight?: number;
  /** THỜI GIAN BAY riêng của phát này (giây). Thiếu ⇒ `SHOT_FLY` (đạn thường). */
  flyTime?: number;
}
/** THỜI GIAN BAY (giây) — NGẮN, để không lệch cảm giác với sát thương đã trúng ngay (task gợi ý 80–140ms). */
const SHOT_FLY = 0.1;
/** THỜI GIAN CHỚP Ở ĐẦU ĐÍCH sau khi tới nơi (giây) — đọc ra "vừa có phát bắn trúng". */
const SHOT_FLASH = 0.08;
/**
 * DEPTH VỆT ĐẠN: TRÊN mọi đơn vị (depth đơn vị = `u.y · 10`, cao nhất ~6000) nhưng DƯỚI lớp hiệu ứng
 * chiêu của scene (8000) và dưới chữ debug/ HUD (9000) ⇒ đạn không che HUD.
 */
const SHOT_DEPTH = 7000;
/** TRẦN SỐ VỆT ĐANG BAY — chặn phình vô hạn nếu sim phát sự kiện lỗi/ dồn dập. */
const SHOT_MAX = 64;
/**
 * VỆT BAY (trail) CỦA VIÊN ĐẠN — dài theo QUÃNG BAY, kẹp lại; giống chế độ đi ải (vệt co giãn theo
 * tốc độ) nhưng Arena biết trước quãng đường nên dùng quãng đó cho vệt "đọc được hướng bay".
 */
const SHOT_TRAIL_MIN = 16;
const SHOT_TRAIL_MAX = 52;




// ════════════════════════════════════════════════════════════════════════════
// 2. HÌNH HỌC + DỮ LIỆU THUẦN — Ở `arena-camera.ts`, RE-EXPORT LẠI CHO TIỆN
// ════════════════════════════════════════════════════════════════════════════

/*
 * ⚠️ VÌ SAO CÁC HÀM NÀY KHÔNG NẰM NGAY Ở ĐÂY — BẪY ĐÃ SẬP, GHI LẠI NGUYÊN VĂN.
 *
 * Bản đầu để `landBand`/ `mineMarkers`/ `carryingIndicator` trong file NÀY (đúng chỗ về mặt khái
 * niệm), và `tests/arena-render.test.ts` ĐỎ ngay: `ReferenceError: window is not defined`, ném ra từ
 * `node_modules/phaser/dist/phaser.esm.js`. Nguyên nhân: file này có `import Phaser from 'phaser'` ở
 * đầu, mà Phaser cần DOM/ WebGL ⇒ **mọi module import nó đều không chạy được trong môi trường node
 * của vitest**.
 *
 * Cách repo này vẫn test được tầng render: lớp hiển thị tách phần THUẦN ra module không import Phaser
 * (xem `tests/fx.test.ts`/ `tests/projectiles.test.ts` — chúng chỉ import `src/sim/` và `src/data/`).
 * Vì vậy hình học nằm ở `arena-camera.ts` (0 import) và được re-export ở đây để nơi dùng chỉ cần một
 * đường import.
 *
 * ⚠️ ĐỪNG "CHO GỌN" BẰNG CÁCH CHÉP LẠI CÁC HÀM ĐÓ VÀO FILE NÀY. Chép là có 2 bản để lệch nhau, mà
 * test chỉ khoá được bản ở `arena-camera.ts` — đúng loại "test xanh trong khi code chạy sai".
 */
export {
  ARENA_FARMER_CAPACITY,
  ARENA_RENDER_MID_X as ARENA_MID_X,
  carryingIndicator,
  mineMarkers,
  mineVisible,
  type ArenaMineLike,
  type ArenaMineMarker,
  type CarryingUnit,
} from './arena-camera';

/*
 * IMPORT THẬT cho phần code bên dưới dùng. `export ... from` KHÔNG tạo biến cục bộ (nó chỉ mở lại
 * đường dẫn tới module kia), nên muốn DÙNG trong file này thì phải import riêng — đây là chỗ dễ
 * tưởng nhầm là "đã export rồi thì dùng được".
 */
import {
  carryingIndicator as carryIndicatorOf,
  mineMarkers as mineMarkersOf,
  mineVisible as mineVisibleOf,
} from './arena-camera';

// ════════════════════════════════════════════════════════════════════════════
// 3. LỚP VẼ THẾ GIỚI
// ════════════════════════════════════════════════════════════════════════════

/**
 * PHẦN `Phaser.Scene` MÀ LỚP VẼ THẬT SỰ CẦN.
 * Khai kiểu tối thiểu để (a) nói rõ nó chỉ đụng những gì, (b) không phải dựng cả Scene thật khi
 * muốn kiểm cấu trúc.
 */
export interface BattleScene {
  add: Phaser.Scene['add'];
  cameras: { main: Phaser.Cameras.Scene2D.Camera };
  scale: Phaser.Scene['scale'];
  /** cần cho `loadBattlefieldArt` — xem `BattlefieldArtScene` (kiểu tối thiểu, không ép kiểu) */
  textures: Phaser.Scene['textures'];
  /** cần cho `ensureProjectileTextures` — vẽ texture đạn DÙNG CHUNG với chế độ đi ải */
  make: Phaser.Scene['make'];
}

/**
 * VẼ THẾ GIỚI ARENA: 3 land × 2 phe · 2 Nhà · 4 mine · chỉ báo nông dân vác đồ · HUD Nhà.
 *
 * Đây là lớp VẼ NỀN + HUD — nó KHÔNG vẽ đơn vị (việc của `UnitViews` qua `ArenaUnitViewsAdapter`)
 * và KHÔNG tính camera (việc của `ArenaCamera`). Tách ba việc ra ba lớp vì mỗi thứ có vòng đời
 * khác nhau: nền vẽ lại khi đổi cỡ, camera cập nhật mỗi khung hình, đơn vị do `UnitViews` quản.
 */
export class ArenaBattleView {
  /** nền thế giới (sông + 2 cầu + màu 2 phe + viền sân) — vẽ lại khi đổi cỡ */
  private bg: Phaser.GameObjects.Graphics;
  /** lớp phủ MỜ nằm TRÊN ảnh sân (depth -97) — nhuộm nhẹ 2 nửa sân mà không che ảnh */
  private tintGfx: Phaser.GameObjects.Graphics;
  /** bệ đá + khối Nhà (depth -95) — TRÊN ảnh sân để nền không "nuốt" mất Nhà */
  private coreGfx: Phaser.GameObjects.Graphics;
  /** lớp vẽ mine — tách khỏi nền vì mine ĐỔI TRẠNG THÁI (cạn dần) nên phải vẽ lại thường xuyên */
  private mineGfx: Phaser.GameObjects.Graphics;
  /** lớp vẽ chỉ báo "đang vác đồ" — vẽ lại MỖI KHUNG HÌNH (theo unit) */
  private carryGfx: Phaser.GameObjects.Graphics;
  /**
   * VỆT ĐẠN ĐANG BAY (thuần HÌNH ẢNH) — xem `ArenaShot`/ `addShots`.
   * Mỗi phần tử là một bản sao có thêm `t` (giây đã bay) để `drawShots` tự bỏ khi hết vòng đời.
   */
  private shots: Array<ArenaShot & { t: number }> = [];
  /** lớp vẽ vệt đạn — depth 7000: trên đơn vị, dưới hiệu ứng chiêu/ HUD (xem `SHOT_DEPTH`) */
  private shotGfx: Phaser.GameObjects.Graphics;
  /**
   * SPRITE ĐẦU ĐẠN — POOL dùng lại, y khuôn `ProjectileLayer` của chế độ đi ải.
   *
   * ⚠️⚠️ ĐỔI TỪ "VẼ ĐOẠN THẲNG" SANG SPRITE THEO SKIN (người dùng yêu cầu): bản trước vẽ mỗi viên đạn
   * bằng `lineStyle + lineTo` (một vệt thẳng màu phe) ⇒ trong Arena đạn trông KHÁC hẳn chế độ đi ải
   * (dép, lá rau, quả pháo, chai rượu…). Nay mỗi viên dùng ĐÚNG texture của chế độ đi ải qua
   * `resolveShotSkin` — xem `skin`/ `kind` ở `ArenaShot` và chú thích ở `render/projectiles.ts`.
   *
   * ⚠️ KHÔNG tạo/ huỷ sprite mỗi viên đạn: chiêu xả liên thanh sinh hàng chục viên/ giây, cấp phát
   * liên tục là tự bắn vào chân (bài học đã ghi ở `ProjectileLayer`).
   */
  private shotPool: Array<{ img: Phaser.GameObjects.Image; trail: Phaser.GameObjects.Image }> = [];
  private shotUsed = 0;
  /**
   * TÊN 2 PHE ĐÃ DỊCH.
   *
   * ⚠️ SAU TASK-11, TẦNG VẼ NÀY KHÔNG CÒN CHỮ NÀO: nhãn `"Phe ta · hp/maxHp"` từng được vẽ ở đỉnh màn
   * hình đã bị XOÁ cùng thanh máu dán đỉnh (máu nay là QUẠT trên bệ đá dưới chân Nhà — `drawCores`).
   * Giữ trường + `buildSideLabels` lại vì `refreshLang()` là một phần hợp đồng của lớp vẽ (scene gọi
   * khi đổi ngôn ngữ, và `tests/arena-render.test.ts` khoá sự tồn tại của method đó). Ai cần đặt tên
   * phe trong thế giới thì dùng sẵn dữ liệu đã dịch ở đây thay vì gọi `t()` lần thứ hai.
   */
  private sideLabels: Record<ArenaSide, string>;
  private disposed = false;
  /*
   * ⚠️⚠️ ẢNH VẼ THẬT (sân sông/ cầu · Nhà · decor) — NGƯỜI DÙNG BÁO KHI CHƠI THỬ: *"có vẻ giống bản
   * demo hơn là bản chơi được"*. ĐO ĐƯỢC trước khi sửa: `ArenaBattleView` vẽ **100% bằng `Graphics`**
   * ⇒ sân là 3 dải màu phẳng, Nhà là 2 khối chữ nhật, không có một mảnh art nào.
   *
   * DÙNG LẠI ĐÚNG hàm nạp của chế độ 10-wave (`loadBattlefieldArt`) chứ KHÔNG chép đường nạp thứ hai:
   * `battlefield-art.ts` lo cắt lưới, tách nền magenta, đặt khoá texture có tiền tố `__tdk_arena_`,
   * và KHÔNG BAO GIỜ ném (thiếu ảnh ⇒ trả ô `null` ⇒ tự lùi về bản vẽ code).
   *
   * ⚠️ ẢNH VỀ MUỘN (nạp mạng bất đồng bộ) nên `applyArt` phải chạy được SAU khi sân đã dựng:
   * mọi thứ ở đây chỉ THAY THẾ lớp vẽ code, không dựng lại từ đầu.
   */
  private art: BattlefieldArt | null = null;
  /**
   * ẢNH SÂN — **MỘT** ảnh, vẽ MỘT LẦN (xem `applyArt`).
   *
   * ⚠️⚠️ ĐỔI TỪ `TileSprite` SANG `Image` — BẮT BUỘC, VÌ ẢNH NAY LÀ MỘT BỨC BẢN ĐỒ:
   * `arena-river.png` chứa SÔNG + ĐÚNG 2 CẦU ở toạ độ khớp `sim/arena/river.ts`. Bản cũ vẽ sàn bằng
   * `tileSprite(...).setTileScale(max(cover))` (LẶP theo kiểu cover) — với ảnh gạch liền mạch thì
   * đúng, còn với ảnh bản đồ thì **sông/ cầu bị lặp nhiều lần trên sân**, đúng lỗi thị giác mà
   * người dùng sẽ thấy ngay. Nay: `coverCrop` cắt đúng tỉ lệ khung (ảnh 5:3, khung 1000×600 = 5:3
   * nên gần như không cắt) rồi `setDisplaySize(ARENA_WORLD)` ⇒ ảnh hiện ĐÚNG MỘT LẦN.
   */
  private fieldImg?: Phaser.GameObjects.Image;
  private decorImgs: Phaser.GameObjects.Image[] = [];
  /** ảnh Nhà của 2 phe — tạo khi có art, cập nhật texture theo % máu (xem `drawCores`) */
  private houseImgs: Partial<Record<ArenaSide, Phaser.GameObjects.Image>> = {};
  /** % máu Nhà mỗi phe — nguồn để chọn trạng thái hư của ảnh Nhà */
  private houseHpPct: Partial<Record<ArenaSide, number>> = {};
  /** trạng thái hư đã vẽ (0 nguyên · 1 nhẹ · 2 nặng) — để KHÔNG `setTexture` lại mỗi khung hình */
  private houseState: Partial<Record<ArenaSide, number>> = {};
  /**
   * NHÃN TRÊN ĐẦU MỖI NHÀ — **SỐ MÁU** (và **TÀI NGUYÊN ĐỊCH** ở Nhà địch).
   *
   * ⚠️⚠️ YÊU CẦU NGƯỜI DÙNG 02/10/2026: *"Ở chế độ arena, số điểm máu và tài nguyên địch để trên đầu
   * nhà chính. Bỏ số máu trên topbar"*. Hai chip `.arena-score` trên thanh HUD đã bị xoá (`hud-arena.ts`)
   * — chúng KHÔNG phải "điểm trận": `score().left` = máu Nhà ĐỊCH, `score().right` = máu Nhà MÌNH.
   * Số máu nay nằm ngay trên Nhà mà nó thuộc về ⇒ không phải nhìn lên đỉnh màn hình rồi đoán.
   *
   * ⚠️ DÙNG ĐỐI TƯỢNG `Text` CỦA PHASER (toạ độ THẾ GIỚI), KHÔNG phải DOM: nhãn phải đi theo camera
   * và theo ZOOM. Nếu vẽ DOM thì HUD phải tự quy đổi world → screen, mà ở khổ dọc có HAI camera (2 tầng)
   * nên phép quy đổi đó cần biết tầng của từng Nhà — đúng loại "hai đường tính toạ độ" mà hợp đồng
   * `ArenaHudHost.worldFromScreen` đã cảnh báo. Ở khổ dọc, mỗi Nhà nằm gọn trong MỘT tầng
   * (Nhà mình x ≈ 65 ⇒ tầng dưới, Nhà địch x ≈ 935 ⇒ tầng trên) nên mỗi camera chỉ vẽ đúng nhãn của
   * tầng mình — không bị vẽ 2 lần như nhãn `setScrollFactor(0)` (xem `updateBandSeam` của scene).
   *
   * ⚠️ CHỈ `setText` KHI CHUỖI ĐỔI: `setText` dựng lại texture của chữ. Máy chữ ở đây chạy mỗi khung
   * hình, mà máu Nhà chỉ đổi khi bị đánh ⇒ so chuỗi trước khi ghi là chênh lệch thật giữa 60 lần/giây
   * và vài lần/ trận.
   */
  private coreHpLabel: Partial<Record<ArenaSide, Phaser.GameObjects.Text>> = {};
  /** nhãn TÀI NGUYÊN của phe — MỖI Nhà một nhãn (Nhà mình = ví mình, Nhà địch = ví địch) */
  private coreResLabel: Partial<Record<ArenaSide, Phaser.GameObjects.Text>> = {};
  /** chuỗi đang hiện của mỗi nhãn — để bỏ qua `setText` khi không đổi */
  private coreHpText: Partial<Record<ArenaSide, string>> = {};
  private coreResText: Partial<Record<ArenaSide, string>> = {};

  constructor(private readonly scene: BattleScene) {
    this.bg = scene.add.graphics().setDepth(-100);
    // lớp phủ nhuộm nhẹ 2 nửa sân — TRÊN ảnh sân (-98) nhưng DƯỚI mọi vạch/ nhãn/ unit
    this.tintGfx = scene.add.graphics().setDepth(-97);
    this.coreGfx = scene.add.graphics().setDepth(-95);
    this.mineGfx = scene.add.graphics().setDepth(-90);
    this.carryGfx = scene.add.graphics().setDepth(40);
    /*
     * VỆT ĐẠN (thuần hình ảnh) — depth 7000: TRÊN mọi đơn vị (đơn vị ≤ ~6000) để đạn không bị nhân vật
     * nuốt, nhưng DƯỚI lớp hiệu ứng chiêu (8000) và HUD/ chữ debug (9000) ⇒ không bao giờ che HUD.
     */
    this.shotGfx = scene.add.graphics().setDepth(SHOT_DEPTH);
    /*
     * TEXTURE ĐẠN — DÙNG CHUNG với chế độ đi ải (cùng khoá `__tdk_proj_*`): gọi ở đây vì Arena có thể
     * vào trước khi lớp đạn của màn 10-wave được tạo. Hàm này idempotent nên gọi thừa cũng vô hại.
     */
    ensureProjectileTextures(scene);
    this.sideLabels = this.buildSideLabels();
    this.drawWorld();
    /*
     * ẢNH VẼ THẬT VỀ SAU (nạp qua mạng) ⇒ thay thế dần lớp vẽ code.
     * KHÔNG `await` ở đây: constructor không được chặn, và `loadBattlefieldArt` không bao giờ ném.
     */
    void loadBattlefieldArt(this.scene)
      .then((art) => this.applyArt(art))
      .catch((err) => console.warn('[arena] nạp ảnh sân thất bại — giữ bản vẽ code:', err));
  }

  /** Tên hiển thị của 2 phe (dịch được) — tách hàm để `refreshLang` gọi lại được. */
  private buildSideLabels(): Record<ArenaSide, string> {
    return {
      left: t(ARENA_TEXT.sideLeft, 'Our side'),
      right: t(ARENA_TEXT.sideRight, 'Enemy side'),
    };
  }

  /**
   * ĐỔI NGÔN NGỮ ⇒ VẼ LẠI CHỮ.
   *
   * Vì sao cần hàm riêng: tên phe được tạo MỘT LẦN trong constructor. Không có đường vẽ lại thì đổi
   * VI→EN giữa trận sẽ để lại chữ tiếng Việt trên HUD — lỗi mà `tests/i18n.test.ts` không bắt được
   * (nó kiểm bảng dịch, không kiểm DOM/ Phaser).
   *
   * ⚠️ SAU TASK-11 hàm này chỉ còn tính lại `sideLabels` (chưa nơi nào vẽ ra); nó KHÔNG bị xoá vì
   * `ArenaBattleScene.refreshLang()` gọi nó và `tests/arena-render.test.ts` khoá sự tồn tại của nó.
   */
  refreshLang(): void {
    if (this.disposed) return;
    this.sideLabels = this.buildSideLabels();
  }

  /**
   * VẼ NỀN THẾ GIỚI — 3 LỚP TÁCH BẠCH THEO DEPTH (mỗi lớp một việc):
   *   · `bg` (-100): BẢN LÙI vẽ sông + 2 cầu khi CHƯA có ảnh bản đồ;
   *   · `fieldImg` (-98): ẢNH bản đồ, vẽ MỘT LẦN (xem `applyArt`);
   *   · `tintGfx` (-97): nhuộm nhẹ 2 nửa sân + làm tối mặt nước + vạch biên — nằm TRÊN ảnh nhưng
   *     DƯỚI đơn vị (depth dương) nên không bao giờ che nhân vật;
   *   · `coreGfx` (-95): bệ đá + khối Nhà, TRÊN ảnh để Nhà không bị nền "nuốt".
   *
   * ⚠️ HÌNH HỌC ĐỌC TỪ `sim/arena/river.ts` (qua re-export của `world.ts`), KHÔNG chép số:
   * `ARENA_RIVER` (2 mép sông) và `ARENA_BRIDGES` (2 khổ cầu). Chép số vào đây là nguồn sự thật thứ
   * hai — ảnh, luật và hình vẽ sẽ lệch nhau mà không ai đo được.
   *
   * ⚠️ ĐÃ XOÁ HẲN "3 LAND": dải màu land, đường kẻ phân land, nhãn land, và vạch chia đôi sân ở giữa
   * (nay giữa sân CHÍNH LÀ SÔNG, vẽ thêm vạch sẽ đè lên mặt nước).
   */
  private drawWorld(): void {
    this.drawFieldFallback();
    this.drawFieldOverlay();
    this.drawCores();
  }

  /** Bản vẽ CODE của sân (sông + cầu) — chỉ hiện khi THIẾU ảnh bản đồ (`hasRiverArt`). */
  private drawFieldFallback(): void {
    const g = this.bg;
    g.clear();
    const { w, h } = ARENA_WORLD;
    if (this.hasRiverArt) return; // ảnh bản đồ đã có sông + cầu ⇒ đừng vẽ chồng bên dưới

    g.fillStyle(0x6b4a33, 1);
    g.fillRect(0, 0, w, h);

    // SÔNG: dải dọc suốt chiều cao (quy ước half-open `[x0, x1)` — xem `ARENA_RIVER`)
    g.fillStyle(WATER_COLOR, 1);
    g.fillRect(ARENA_RIVER.x0, 0, ARENA_RIVER.width, h);
    // 2 CẦU: dải ngang bắc qua sông, khổ cầu đọc từ sim (KHÔNG hard-code 160)
    for (const b of ARENA_BRIDGES) {
      const bh = b.bottom - b.top;
      // mặt cầu nhô ra mỗi bên nửa khổ cầu (≈40 đơn vị, gần đúng ~47 mà prompt của ảnh yêu cầu)
      const deckW = ARENA_RIVER.width + ARENA_BRIDGE_HALF;
      g.fillStyle(BRIDGE_COLOR, 1);
      g.fillRect(ARENA_RIVER.centerX - deckW / 2, b.top, deckW, bh);
      g.lineStyle(2, BRIDGE_EDGE, 0.9);
      g.lineBetween(ARENA_RIVER.centerX - deckW / 2, b.top, ARENA_RIVER.centerX + deckW / 2, b.top);
      g.lineBetween(ARENA_RIVER.centerX - deckW / 2, b.bottom, ARENA_RIVER.centerX + deckW / 2, b.bottom);
    }
  }

  /**
   * LỚP PHỦ TRÊN ẢNH — hai việc, mỗi việc có lý do chơi-game:
   *   1. NHUỘM NHẸ 2 NỬA SÂN (chỉ trên 2 BỜ, KHÔNG phủ mặt sông): mắt đọc ra ngay "đất mình/ đất
   *      địch" mà không phải nhìn Nhà — ảnh bản đồ vẽ 2 nửa giống hệt nhau nên tín hiệu này cần thiết.
   *   2. LÀM TỐI MẶT NƯỚC: giữ unit không "dính" vào nền nước sáng (art nước nhạt hơn đá ở vài vùng).
   *
   * ⚠️⚠️ CỐ Ý **KHÔNG** VẼ VẠCH MÉP KHỔ CẦU CỦA SIM LÊN MẶT NƯỚC — ĐÃ ĐO TRƯỚC KHI QUYẾT:
   *
   * ⚠️ SỐ Ở ĐÂY ĐÃ ĐƯỢC CẬP NHẬT (2026-10-02) — bản cũ nói "ảnh vẽ cầu HẸP HƠN khổ cầu của luật,
   * chênh ~28 đơn vị mỗi đầu, đã chấp nhận". ĐIỀU ĐÓ NAY SAI VÀ CHÍNH NÓ LÀ MỘT BUG: dải cầu của sim
   * rộng hơn mặt gỗ vẽ trên ảnh ⇒ unit ĐỨNG ĐƯỢC TRÊN NƯỚC ở rìa cầu (người dùng báo: *"khung cầu bạn
   * vẽ bị to hơn ảnh"*). Nay dải sim đã được THU cho NẰM TRONG mặt gỗ:
   *   · cầu TRÊN: sim `[105, 209)` — mặt gỗ ảnh `[101,2, 213,0)` ⇒ inset 3,8 trên · 4,0 dưới;
   *   · cầu DƯỚI: sim `[377, 481)` — mặt gỗ ảnh `[372,0, 486,0)` ⇒ inset 5,0 · 5,0.
   * (Hai hằng số đo từ ảnh là `ARENA_BRIDGE_DECK_TOP/BOTTOM` ở `river.ts`; đổi ảnh thì PHẢI đo lại.)
   *
   * Vì sim nay đã nằm GỌN trong mặt gỗ, vẽ vạch mép khổ cầu là thừa — và vẫn là thứ gây rối mắt:
   * bản thử trước đây để lại các VẠCH MẢNH, trông như vết ghép ảnh (thấy rõ trên ảnh chụp 844×390).
   * Thay vào đó tôi ĐO phân bố `y` của MỌI unit lúc đang ở trong dải sông (3 trận × 240s, 13 290 mẫu):
   *   · cầu TRÊN: min 134,6 · p5 154,4  ⇒ nằm TRỌN trong mặt gỗ;
   *   · cầu DƯỚI: p50 402,5 · p95 441,4 · max 458,9 ⇒ nằm TRỌN trong mặt gỗ.
   * ⇒ Không unit nào đứng ngoài mặt cầu đã vẽ, nên vạch đánh dấu là thừa; bỏ nó đi thì sân sạch hơn
   * mà bất biến "unit đi trên cầu trông đúng" vẫn đúng.
   * ⚠️ Con số ở đây là BẰNG CHỨNG, KHÔNG phải giả định: đổi `ARENA_BRIDGE_HALF`/ tâm cầu/ `crossingY`
   * là phải ĐO LẠI (`tests/arena-river.test.ts` có bài khoá `dải sim ⊆ mặt gỗ` chống tái phát).
   */
  private drawFieldOverlay(): void {
    const g = this.tintGfx;
    g.clear();
    const { w, h } = ARENA_WORLD;
    const hasArt = !!this.art?.river || !!this.art?.floor;

    // 1. nhuộm nhẹ 2 bờ (KHÔNG phủ mặt sông — tránh nửa xanh nửa đỏ trên cùng một dòng nước)
    g.fillStyle(SIDE_COLOR.left.deep, hasArt ? 0.16 : 0.3);
    g.fillRect(0, 0, ARENA_RIVER.x0, h);
    g.fillStyle(SIDE_COLOR.right.deep, hasArt ? 0.16 : 0.3);
    g.fillRect(ARENA_RIVER.x1, 0, w - ARENA_RIVER.x1, h);

    // 2. làm tối mặt nước — CHỈ khi ảnh đã có sông (bản lùi đã tự tô nước đủ tối)
    if (this.hasRiverArt) {
      g.fillStyle(0x0b1418, 0.14);
      g.fillRect(ARENA_RIVER.x0, 0, ARENA_RIVER.width, h);
      g.lineStyle(2, WATER_EDGE, 0.35);
      g.lineBetween(ARENA_RIVER.x0, 0, ARENA_RIVER.x0, h);
      g.lineBetween(ARENA_RIVER.x1, 0, ARENA_RIVER.x1, h);
    }

    // viền sân — luôn ở TRÊN ảnh (nếu để dưới, ảnh che mất khung)
    g.lineStyle(4, 0x1c1917, 0.9);
    g.strokeRect(0, 0, w, h);
  }

  /** Ảnh bản đồ (sông + 2 cầu) đã nạp được chưa — quyết định có vẽ bản lùi hay không. */
  private get hasRiverArt(): boolean {
    return !!this.art?.river;
  }

  /**
   * ẢNH VẼ THẬT VỀ ⇒ THAY THẾ LỚP VẼ CODE (sân sông/ cầu · Nhà · decor).
   *
   * ⚠️ THỨ TỰ + DEPTH LÀ ĐIỀU KIỆN ĐÚNG, không phải chi tiết phụ:
   *   · `bg` (bản lùi sông/ cầu) ở depth -100
   *   · `fieldImg` ở depth **-98**: NẰM TRÊN bản lùi
   *   · `tintGfx` (nhuộm nhẹ) ở **-97**, `coreGfx` (Nhà) ở **-95**
   *   · `decor` ở depth **-70..-60** (như chế độ 10-wave): luôn ÂM nên nhân vật (depth dương)
   *     luôn đi TRƯỚC decor ⇒ prop không bao giờ che tướng.
   *
   * ⚠️⚠️ ẢNH SÂN VẼ **MỘT LẦN** — KHÔNG LẶP. Đây là điểm khác căn bản so với bản cũ (dùng
   * `tileSprite` + `tileScale` kiểu cover): `arena-river.png` là MỘT BỨC BẢN ĐỒ có sông + đúng 2 cầu
   * khớp `sim/arena/river.ts`. Lặp nó là sông/ cầu xuất hiện nhiều lần trên sân.
   * `coverCrop` giữ đúng tỉ lệ ảnh (không bóp méo) rồi `setDisplaySize(ARENA_WORLD)` ⇒ ảnh phủ kín
   * sân ĐÚNG MỘT LẦN. Ảnh 5:3 và khung 1000×600 cũng 5:3 nên phần bị cắt ≈ 0.
   *
   * ⚠️ CHỌN ẢNH: ưu tiên `art.river` (bản đồ sông/ cầu của Arena PVE). `art.floor` (gạch liền mạch
   * của chế độ 10-wave) chỉ là phương án lùi để sân vẫn có nền khi ảnh mới thiếu.
   */
  private applyArt(art: BattlefieldArt): void {
    if (this.disposed) return;
    this.art = art;
    const { w, h } = ARENA_WORLD;
    const fieldKey = art.river ?? art.floor;

    if (fieldKey && !this.fieldImg) {
      const src = this.scene.textures.get(fieldKey).getSourceImage() as { width: number; height: number };
      if (src.width > 0 && src.height > 0) {
        const crop = coverCrop(src.width, src.height, w, h);
        this.fieldImg = this.scene.add
          .image(w / 2, h / 2, fieldKey)
          .setCrop(crop.x, crop.y, crop.width, crop.height)
          .setDisplaySize(w, h)
          .setDepth(-98)
          .setAlpha(0.98);
      }
    }

    // decor: rải ở 4 GÓC + 2 mép (tránh vùng sông/ cầu và vùng Nhà) — không che đường đi của lính
    if (art.decor.some((k) => k !== null)) {
      for (const o of this.decorImgs) o.destroy();
      this.decorImgs = [];
      /*
       * ⚠️ VỊ TRÍ DECOR ĐÃ ĐỔI THEO LUẬT MỚI: bản cũ rải prop ở 2 dải NGOÀI 3 land. Nay không còn
       * dải nào, và vùng giữa sân là SÔNG + 2 CẦU (không được đặt prop lên đó — che cầu là lỗi chơi
       * game). Vì vậy prop chỉ nằm ở 4 GÓC, cách xa cả sông lẫn 2 Nhà.
       * Neo ĐÁY (0.5, 1) cho mọi prop để chúng "đứng" trên mặt sân.
       */
      const slots: Array<{ x: number; y: number; h: number }> = [
        { x: w * 0.2, y: h * 0.16, h: h * 0.13 },
        { x: w * 0.34, y: h * 0.12, h: h * 0.1 },
        { x: w * 0.68, y: h * 0.12, h: h * 0.1 },
        { x: w * 0.82, y: h * 0.16, h: h * 0.13 },
        { x: w * 0.24, y: h * 0.88, h: h * 0.12 },
        { x: w * 0.76, y: h * 0.88, h: h * 0.12 },
      ];
      let slot = 0;
      for (let i = 0; i < art.decor.length && slot < slots.length; i++) {
        const key = art.decor[i];
        if (!key) continue;
        const s = slots[slot++];
        const src = this.scene.textures.get(key).getSourceImage() as { width: number; height: number };
        if (!src.width || !src.height) continue;
        const scale = Math.min(s.h / src.height, (w * 0.12) / src.width);
        this.decorImgs.push(
          this.scene.add
            .image(s.x, s.y, key)
            .setOrigin(0.5, 1)
            .setScale(scale)
            .setAlpha(0.95)
            // depth ÂM ⇒ luôn nằm dưới nhân vật; chênh nhẹ theo y để có cảm giác chiều sâu
            .setDepth(-70 + (s.y / h) * 6),
        );
      }
    }

    // vẽ lại nền (bản lùi tắt khi có ảnh sông) + lớp phủ + Nhà (dùng ảnh thay khối chữ nhật)
    this.drawWorld();
  }

  /**
   * VẼ 2 NHÀ TRONG THẾ GIỚI — BỆ ĐÁ · **MIẾNG PIE MÁU** · THÂN NHÀ · VÒNG "CỔNG".
   *
   * ⚠️⚠️ THỨ TỰ VẼ TRONG HÀM NÀY LÀ MỘT PHẦN CỦA YÊU CẦU, KHÔNG PHẢI "CHO GỌN":
   * bệ đá → **quạt máu** → thân Nhà → vòng "cổng". Quạt vẽ TRƯỚC thân Nhà nên nằm **BEHIND NHÀ**
   * (người dùng chốt: *"fill vừa bằng cái bóng và behind nhà"*); cả `coreGfx` (depth −95) cũng đã nằm
   * DƯỚI ảnh Nhà (−94) nên ảnh Nhà cũng đè lên quạt. Đảo thứ tự hai dòng là quạt chui lên trước mặt Nhà.
   *
   * ⚠️⚠️ CỠ NHÀ ĐỔI TỪ `ARENA_CORE.radius` SANG `ARENA_CORE_DRAW_R` — ĐỌC KỸ VÌ ĐÂY LÀ BẪY LỚN:
   * `ARENA_CORE.radius` (≈24,17) là **BÁN KÍNH MỤC TIÊU** — nó tham gia `reach = range + core.radius`
   * trong sim nên sửa nó là ĐỔI CÂN BẰNG (đo được: tỉ lệ thắng tán xạ 20–63%). Còn "Nhà to hơn" là
   * yêu cầu HÌNH ẢNH, và hình ảnh dùng hằng số riêng `ARENA_CORE_DRAW_R` (≈45,83, ≈1,9×). Bản cũ vẽ
   * bằng `ARENA_CORE.radius` ⇒ sau refactor Nhà co lại một nửa so với cỡ người dùng đã chốt.
   *
   * ⚠️ Vòng "cổng ra quân" vẫn dùng `ARENA_CORE_BODY_RADIUS` (vỏ VA CHẠM, ≈27,5) — đó là hình chiếu
   * của một con số VẬT LÝ, không phải cỡ vẽ và KHÔNG phải chỗ hiện máu. Ba số này KHÔNG được gộp (xem
   * chú thích trong `sim/arena/world.ts`).
   *
   * ⚠️ Nhà nay là một KHỐI GỌN quanh `ARENA_CORE_Y` ở giữa mép sân, KHÔNG còn là "tường cao chạm cả
   * 3 land": luật cũ đo điều kiện thắng theo trục X vì Nhà cao chạm mọi land; nay không còn land, và
   * mục tiêu của sim là hình tròn tại `(x, ARENA_CORE_Y)`. Vẽ một khối cao suốt sân sẽ gợi ý sai rằng
   * đánh ở đâu trên khối cũng trúng Nhà.
   *
   * ⚠️ `world = null` = ĐƯỜNG TĨNH (`resize()`/ ảnh Nhà nạp xong): vẽ y hệt nhưng BỎ quạt máu (không có
   * số máu để đọc). Khung hình sau đó `update()` sẽ vẽ lại kèm quạt — xem `update`.
   */
  private drawCores(world: ArenaWorld | null = null): void {
    const g = this.coreGfx;
    g.clear();
    const R = ARENA_CORE_DRAW_R;
    const cy = ARENA_CORE_Y;
    const baseY = cy + CORE_BASE_DY;
    const hasHouseArt = !!this.art?.house.some((c) => c !== null);
    for (const side of ['left', 'right'] as ArenaSide[]) {
      const x = side === 'left' ? ARENA_CORE.leftX : ARENA_CORE.rightX;
      const col = SIDE_COLOR[side];

      /*
       * % MÁU — chỉ có khi gọi từ vòng lặp khung hình. Đây cũng là chỗ ĐẨY % MÁU SANG ẢNH NHÀ (3 trạng
       * thái hư, xem `syncHouseArt`). ⚠️ CHỈ gọi `syncHouseArt` khi TRẠNG THÁI ĐỔI (ngưỡng 0.5/ 0.25):
       * mỗi lượt gọi là một lượt `setTexture`/ `setScale` trên 2 đối tượng — 60 lần/giây là phí và có
       * thể gây nháy hình.
       */
      let pct = 1;
      if (world) {
        const core = world.cores[side];
        pct = Math.max(0, Math.min(1, core.hp / Math.max(1, core.maxHp)));
        const state = pct > 0.5 ? 0 : pct > 0.25 ? 1 : 2;
        if (this.houseHpPct[side] === undefined || this.houseState[side] !== state) {
          this.houseHpPct[side] = pct;
          this.houseState[side] = state;
          this.syncHouseArt();
        } else {
          this.houseHpPct[side] = pct; // giữ số mới nhất để lần đổi trạng thái sau dùng đúng
        }
      }

      /*
       * (1) NỀN MÓNG = **PHẦN MÁU ĐÃ MẤT** (và vẫn là "bóng" cho Nhà đứng lên).
       *
       * ⚠️ NGƯỜI DÙNG DUYỆT PIE RỒI XIN DỊU HƠN: *"Pie máu nhà cho blur kiểu transparent hơn cho đẹp."*
       * ⇒ nền hạ từ `0x3f3f46 @0,9` (đá xám đặc) xuống **`0x27272a` @0,42** (tối, trong) — chênh lệch
       * với miếng pie vẫn phải đọc được, nên KHÔNG hạ cả hai xuống mức không phân biệt nổi.
       * Viền ellipse vẫn giữ: nó là thứ đọc ra "bệ đá" khi Nhà đã vỡ (không còn miếng pie nào).
       */
      g.fillStyle(0x27272a, 0.42);
      g.fillEllipse(x, baseY, R * 3.4, R * 0.95);
      g.lineStyle(3, 0x27272a, 0.8);
      g.strokeEllipse(x, baseY, R * 3.4, R * 0.95);

      /*
       * (2) **QUẠT MÁU** (pie) — phần máu CÒN LẠI, quét từ TÂM bệ đá ra.
       *
       * ⚠️ VẼ Ở ĐÂY (trước thân Nhà) LÀ CỐ Ý: quạt phải "behind nhà".
       * ⚠️ Điểm ĐẦU TIÊN phải là TÂM `(x, baseY)` — thiếu nó thì hình thành ĐA GIÁC/ vành khuyên chứ
       * không ra miếng quạt.
       * ⚠️ `pct = 0` ⇒ không vẽ (chỉ còn nền tối = "Nhà đã vỡ"); `pct = 1` ⇒ quạt phủ KÍN ellipse
       * (vì điểm cuối quay về đúng điểm đầu).
       *
       * ⚠️⚠️ ĐỘ TRONG: `0,9` → **`0,38`** theo yêu cầu "transparent hơn cho đẹp" — miếng màu bão hoà lớn
       * hút mắt hơn cả cái Nhà. Tiêu chí là **NHÀ vẫn là thứ nổi nhất, quạt chỉ là NỀN THÔNG TIN**.
       * Bù lại độ tương phản bằng (2b) VIỀN SÁNG MẢNH dọc đúng cung — mắt đọc ranh giới "còn bao nhiêu"
       * trong khi ruột vẫn trong.
       */
      if (pct > 0) {
        /*
         * ⚠️⚠️ KHÔNG tạo ĐỐI TƯỢNG ĐIỂM của Phaser ở đây — ĐỌC KỸ, ĐÃ SẬP MỘT LẦN:
         * `src/render/arena-battle.ts` có `import Phaser from 'phaser'` từ trước, nhưng MỌI chỗ dùng
         * đều là **KIỂU** (`Phaser.GameObjects.Graphics`, `Phaser.Scene['add']`…) nên TypeScript/ esbuild
         * **ELIDE** import ⇒ Phaser KHÔNG được nạp lúc chạy ⇒ test node (vitest) import được file này qua
         * `ui/hud-arena.ts` mà không nổ `window is not defined`.
         * Một dòng kiểu `new` + lớp `Vector2` của Phaser là dùng **GIÁ TRỊ** ⇒ import hết bị elide ⇒ nạp thật
         * ⇒ `ReferenceError: window is not defined` ⇒ `tests/arena-hud-drag.test.ts` chết (0 test).
         * Vì vậy quạt + viền được dựng bằng `beginPath`/`moveTo`/`lineTo`/`fillPath`/`strokePath` với TOẠ
         * ĐỘ SỐ — không cần đối tượng điểm nào của Phaser, import vẫn là import KIỂU như cũ.
         * (`fillPoints`/ `strokePoints` cũng dùng được nhưng phải truyền `Phaser.Math.Vector2[]`, tức lại
         * kéo Phaser vào dạng giá trị — trừ khi ép kiểu, mà ép kiểu ở đây là không cần thiết.)
         */
        const sweep = Math.PI * 2 * pct;
        g.fillStyle(col.base, 0.38);
        g.beginPath();
        g.moveTo(x, baseY); // ĐIỂM ĐẦU = TÂM
        for (let i = 0; i <= CORE_PIE_SEGMENTS; i++) {
          const t = CORE_PIE_START + sweep * (i / CORE_PIE_SEGMENTS);
          g.lineTo(x + CORE_BASE_A * Math.cos(t), baseY + CORE_BASE_B * Math.sin(t));
        }
        g.closePath();
        g.fillPath();

        // (2b) VIỀN MỀM dọc ĐÚNG CUNG của quạt (KHÔNG có tâm) — "blur" bằng nét mảnh alpha thấp
        g.lineStyle(2, col.edge, 0.5);
        g.beginPath();
        for (let i = 0; i <= CORE_PIE_SEGMENTS; i++) {
          const t = CORE_PIE_START + sweep * (i / CORE_PIE_SEGMENTS);
          const px = x + CORE_BASE_A * Math.cos(t);
          const py = baseY + CORE_BASE_B * Math.sin(t);
          if (i === 0) g.moveTo(px, py);
          else g.lineTo(px, py);
        }
        g.strokePath();
      }

      /*
       * (3) THÂN/ THÀNH NHÀ — **BẢN LÙI, CHỈ VẼ KHI CHƯA CÓ ẢNH NHÀ**.
       *
       * ⚠️⚠️ NGƯỜI DÙNG: *"Bỏ khung hình vuông màu xanh/đỏ trên nhà đi"*. Có ảnh Nhà thì CHÍNH ẢNH đã
       * là hình dạng của Nhà, còn khung vuông chỉ là một cái HỘP MÀU đè lên cảnh (nó cũng không khớp
       * silhouette của ảnh nên đọc ra như một cái lỗi vẽ).
       *
       * ⚠️ NHƯNG KHÔNG ĐƯỢC BỎ CẢ NHÁNH: lúc ảnh chưa nạp/ 404 thì khung này là thứ DUY NHẤT vẽ ra
       * "Nhà" (bệ đá chỉ là nền, vòng "cổng" chỉ là một chấm ở tâm) ⇒ bỏ sạch là người chơi không thấy
       * Nhà đâu. Đây đúng quy ước "bản lùi khi thiếu art" của repo (`drawWorld`/ `hasRiverArt`).
       */
      if (!hasHouseArt) {
        g.fillStyle(col.deep, 0.85);
        g.fillRect(x - R, cy - R, R * 2, R * 2);
        g.lineStyle(3, col.edge, 0.7);
        g.strokeRect(x - R, cy - R, R * 2, R * 2);
      }

      // (4) "CỔNG" của Nhà ở TÂM — chỗ lính đi ra, dùng đúng vỏ va chạm của sim (GIỮ NGUYÊN, không phải chỗ hiện máu)
      g.fillStyle(col.base, 0.9);
      g.fillCircle(x, cy, ARENA_CORE_BODY_RADIUS);
      g.lineStyle(2, col.edge, 0.9);
      g.strokeCircle(x, cy, ARENA_CORE_BODY_RADIUS);
    }
    /*
     * Đường TĨNH (resize/ art về) vẫn phải đồng bộ ẢNH NHÀ: lúc đó `houseHpPct` đã có số từ khung hình
     * trước, hoặc chưa có gì thì `syncHouseArt` tự dùng mặc định 1 (Nhà nguyên vẹn).
     */
    if (!world) this.syncHouseArt();
  }

  /**
   * ẢNH NHÀ THEO % MÁU — 3 trạng thái: `>0.5` nguyên vẹn · `>0.25` hư nhẹ · còn lại hư nặng.
   *
   * DÙNG LẠI đúng ngưỡng của chế độ 10-wave (`ArenaView.showHouse`) chứ không tự đặt ngưỡng mới:
   * hai chế độ phải hỏng Nhà giống nhau, nếu không người chơi thấy game "đổi luật" giữa hai màn.
   *
   * ⚠️⚠️ CỠ ẢNH PHẢI KHỚP CÁI BOX MÀ NÓ ĐƯỢC VẼ VÀO — BUG NGƯỜI DÙNG BÁO, ĐÃ SỬA.
   *
   * Người dùng: *"Cho ngôi nhà nhỏ lại, hiện đang vượt quá kích cỡ vùng box kích cỡ của nó rồi"*.
   *
   * SỐ ĐO RA NGUYÊN NHÂN: `drawCores` vẽ BOX của Nhà là `fillRect(x − R, cy − R, R·2, R·2)` với
   * `R = ARENA_CORE_DRAW_R` ⇒ box rộng `2R ≈ 91,7`. Nhưng ảnh Nhà ở đây lại vẽ ở `target = 4,2 · R
   * ≈ 192,5` — **ảnh to gấp 2,1 lần chính cái box của nó**, nên nó tràn ra ngoài viền box ở cả 4 phía.
   * (Hệ số 4,2 là DI SẢN của thời ảnh Nhà là thứ DUY NHẤT được vẽ — khi đó chưa có box nào để khớp.
   * Khi `drawCores` thêm box, hệ số đó thành ra sai mà không ai đổi.)
   *
   * CÁCH SỬA: `target = 2 · R` = ĐÚNG bằng box. Ảnh nằm gọn trong nền móng của nó, và Nhà không còn
   * tràn khỏi vùng va chạm/ mục tiêu mà sim dùng để tính luật.
   *
   * ⚠️ DÙNG `2 · R` CHỨ KHÔNG hard-code px: đổi `ARENA_CORE_DRAW_R` là box VÀ ảnh cùng đổi theo,
   * không thể lệch lại. Đây đúng là bẫy đã sập một lần (hệ số cứng 4,2 nằm lại khi box đổi).
   */
  private syncHouseArt(): void {
    const cells = this.art?.house;
    if (!cells || !cells.some((c) => c !== null)) return;
    const R = ARENA_CORE_DRAW_R;
    /* `2·R` = đúng bề rộng box ở `drawCores` ⇒ ảnh khớp nền móng, không tràn viền. */
    const target = R * 2;
    const baseY = ARENA_CORE_Y + R * 0.9;
    for (const side of ['left', 'right'] as ArenaSide[]) {
      const x = side === 'left' ? ARENA_CORE.leftX : ARENA_CORE.rightX;
      const hpPct = this.houseHpPct[side] ?? 1;
      let idx = hpPct > 0.5 ? 0 : hpPct > 0.25 ? 1 : 2;
      // ô trạng thái mong muốn có thể TRỐNG (AI chỉ vẽ 1–2 ô) ⇒ lùi về ô ĐẦU có ảnh
      let key = cells[idx]?.key ?? null;
      if (!key) {
        const fallback = cells.findIndex((c) => c !== null);
        if (fallback < 0) continue;
        key = cells[fallback]!.key;
      }
      const existing = this.houseImgs[side];
      if (!existing) {
        this.houseImgs[side] = this.scene.add
          .image(x, baseY, key)
          .setOrigin(0.5, 1)
          .setDepth(-94);
      } else if (existing.texture.key !== key) {
        existing.setTexture(key);
      }
      /*
       * ⚠️⚠️ NHÀ BÊN PHẢI PHẢI LẬT (`flipX`) — YÊU CẦU NGƯỜI DÙNG: *"Nhà bên phải phải flip lại cho
       * đúng chiều"*. QUYẾT ĐỊNH "phe nào lật" nằm ở `houseArtFlipX` (`arena-camera.ts`, hàm thuần đã
       * có test) — ở đây chỉ THI HÀNH, không tự phán `side === 'right'` lần nữa.
       *
       * Vì sao cần: ảnh `art/ai/house.png` chỉ vẽ MỘT chiều (mặt tiền quay sang phải) ⇒ vẽ nguyên
       * chiều cho cả hai Nhà là Nhà PHẢI quay lưng vào sân, hai Nhà "nhìn" cùng hướng.
       *
       * 🔢 CÁCH LẬT: `setFlipX` gương quanh TRỤC X của chính đối tượng; ảnh đặt `origin = (0.5, 1)`
       * (tâm-đáy) nên gương diễn ra quanh TÂM NGANG — Nhà không xê dịch, chỉ đổi chiều. KHÔNG được
       * "lật" bằng cách đổi dấu `scaleX` thủ công: `syncHouseArt` tính `scale` mỗi khung hình từ kích
       * thước texture (ảnh 3 ô cao thấp khác nhau), nên `scaleX` âm sẽ bị lần tính sau ghi đè.
       *
       * ⚠️ ĐẶT Ở ĐÂY (ngoài nhánh `if (!existing)`) vì hàm còn chạy lại mỗi khi ảnh đổi trạng thái
       * hư: gán lại mỗi lượt là cách DUY NHẤT bảo đảm ảnh vừa `setTexture` xong cũng đã lật, không
       * phụ thuộc thứ tự tạo/ cập nhật. (Phép gán này rẻ và không gây nháy hình — cùng lý do repo đã
       * ghi cho `setScale`/ `setTint` bên dưới.)
       */
      this.houseImgs[side]!.setFlipX(houseArtFlipX(side));
      // scale tính MỖI LẦN (ảnh 3 ô có thể cao thấp khác nhau) — rẻ và luôn đúng
      const src = this.scene.textures.get(key).getSourceImage() as { width: number; height: number };
      if (!src.width || !src.height) continue;
      const scale = Math.min(target / src.height, target / src.width);
      this.houseImgs[side]!.setScale(scale);
      /*
       * ĐẨY % MÁU LÊN ẢNH — ảnh có 3 trạng thái hư; nhưng tầng vẽ cũng đổi màu theo máu để tín hiệu
       * "Nhà sắp vỡ" đọc được ngay cả khi ảnh chưa về (xem `drawCores` gọi `syncHouseArt` khi
       * trạng thái ĐỔI, không mỗi khung hình).
       */
      const tint = hpPct > 0.5 ? 0xffffff : hpPct > 0.25 ? 0xffd9b8 : 0xff9c7a;
      this.houseImgs[side]!.setTint(tint);
    }
  }

  /**
   * NHÃN TRÊN ĐẦU MỖI NHÀ: **SỐ MÁU** + **TÀI NGUYÊN** của chính phe đó.
   *
   * Yêu cầu người dùng 02/10/2026: *"số điểm máu và tài nguyên địch để trên đầu nhà chính. Bỏ số máu
   * trên topbar"* rồi *"Tài nguyên địch đã có trên header nhà địch nhưng tài nguyên quân ta chưa có
   * chuyển lên header nhà quân mình"*. Hai chip `.arena-score` và chip `.arena-res` trên thanh HUD đã bị
   * xoá — chúng KHÔNG phải "điểm trận": `ArenaWorld.score().left` = máu Nhà ĐỊCH, `.right` = máu Nhà MÌNH
   * (xem chú thích `score()`). Nay mỗi Nhà hiện máu + ví CỦA CHÍNH NÓ ⇒ không phải nhìn lên đỉnh màn
   * hình rồi đoán số nào của ai.
   *
   * ⚠️ VÌ SAO `Text` CỦA PHASER (toạ độ THẾ GIỚI) CHỨ KHÔNG PHẢI DOM: nhãn phải đi theo camera VÀ co
   * theo ZOOM của từng khổ màn. Nếu vẽ DOM thì HUD phải tự quy đổi world → screen, mà ở khổ dọc có HAI
   * camera (2 tầng) nên phép quy đổi đó cần biết tầng của từng Nhà — đúng loại "hai đường tính toạ độ"
   * mà hợp đồng `ArenaHudHost.worldFromScreen` đã cảnh báo. Ở khổ dọc mỗi Nhà nằm gọn trong MỘT tầng
   * (Nhà mình x ≈ 65 ⇒ tầng dưới · Nhà địch x ≈ 935 ⇒ tầng trên) nên mỗi camera chỉ vẽ đúng nhãn của
   * tầng mình — không bị vẽ 2 lần như nhãn `setScrollFactor(0)` (xem `updateBandSeam` ở scene).
   *
   * ⚠️⚠️ CHỈ `setText` KHI CHUỖI ĐỔI: `setText` dựng lại texture của chữ. Hàm này chạy MỖI KHUNG HÌNH,
   * mà máu Nhà chỉ đổi khi bị đánh ⇒ so chuỗi trước khi ghi là chênh lệch giữa 60 lần/giây và vài lần
   * mỗi trận. Đây cũng là lý do nhãn KHÔNG được vẽ lại bằng `drawCores` (nó là `Graphics`, chữ phải là
   * đối tượng riêng).
   *
   * ⚠️ MỌI SỐ QUA `formatArenaResource()` (cùng nguồn với mọi số khác của Arena) và mọi CHỮ qua `t()` —
   * nhãn này cũng phải đổi khi người chơi đổi ngôn ngữ giữa trận (hàm chạy lại mỗi khung hình nên tự
   * bắt được, không cần `refreshLang` làm gì thêm).
   */
  private updateCoreLabels(world: ArenaWorld): void {
    const R = ARENA_CORE_DRAW_R;
    for (const side of ['left', 'right'] as ArenaSide[]) {
      const x = side === 'left' ? ARENA_CORE.leftX : ARENA_CORE.rightX;
      const hpText = `♥ ${formatArenaResource(world.cores[side].hp)}`;
      let hp = this.coreHpLabel[side];
      if (!hp) {
        hp = this.scene.add
          .text(0, 0, hpText, {
            fontFamily: 'system-ui, sans-serif',
            fontSize: '16px',
            fontStyle: 'bold',
            color: CORE_LABEL_COLOR[side],
            align: 'center',
            backgroundColor: 'rgba(12, 9, 7, 0.72)',
            padding: { x: 6, y: 2 },
          })
          .setOrigin(0.5, 1)
          .setDepth(CORE_LABEL_DEPTH);
        this.coreHpLabel[side] = hp;
        this.coreHpText[side] = hpText;
      } else if (this.coreHpText[side] !== hpText) {
        hp.setText(hpText);
        this.coreHpText[side] = hpText;
      }
      /*
       * ĐÁY NHÃN = `cy − R − 8`: ảnh Nhà có `origin (0.5, 1)` tại `cy + 0,9R` và cao tối đa `2R`
       * (xem `syncHouseArt`) ⇒ đỉnh ảnh ở `cy − 1,1R`; chừa thêm 8 đơn vị cho nhãn không đè mái Nhà.
       */
      const hpBottom = ARENA_CORE_Y - R - 8;
      hp.setPosition(clampLabelX(x, hp.width), hpBottom);

      /*
       * TÀI NGUYÊN CỦA CHÍNH PHE ĐÓ — người dùng: *"Tài nguyên địch đã có trên header nhà địch nhưng tài
       * nguyên quân ta chưa có chuyển lên header nhà quân mình"* ⇒ nay MỖI Nhà hiện ví của phe mình:
       * Nhà MÌNH = `world.resource.left` (ví Arena của người chơi), Nhà ĐỊCH = `world.resource.right`.
       *
       * ⚠️ Nhãn địch có chữ "địch", nhãn ta thì không — đọc cạnh nhau là rõ, và bớt được một chuỗi i18n
       * trùng nghĩa ("Tài nguyên ta" vs "Tài nguyên").
       *
       * ⚠️ HIỆN KÈM TRẦN (`ARENA_ECON.maxResource`, yêu cầu *"để tiền trong arena max 200G"*): không
       * hiện trần thì người chơi thấy ví ĐỨNG YÊN khi đang đào và tưởng nông dân hỏng. Trần áp cho cả
       * hai phe nên hai nhãn cùng dạng `số/trần`.
       */
      const resCap = formatArenaResource(ARENA_ECON.maxResource);
      const isMaxGold = world.resource[side] >= ARENA_ECON.maxResource;
      const resText =
        side === 'right'
          ? `${t('Tài nguyên địch', 'Enemy resource')} ${formatArenaResource(world.resource.right)}/${resCap}${isMaxGold ? ' ⚠️ MAX' : ''}`
          : `${t(ARENA_TEXT.resource, 'Resource')} ${formatArenaResource(world.resource.left)}/${resCap}${isMaxGold ? ` ⚠️ ${t('MAX VÀNG!', 'MAX GOLD!')}` : ''}`;
      let res = this.coreResLabel[side];
      if (!res) {
        res = this.scene.add
          .text(0, 0, resText, {
            fontFamily: 'system-ui, sans-serif',
            fontSize: '13px',
            fontStyle: 'bold',
            color: isMaxGold ? '#ef4444' : '#fde68a',
            align: 'center',
            backgroundColor: isMaxGold ? 'rgba(80, 10, 10, 0.88)' : 'rgba(12, 9, 7, 0.72)',
            padding: { x: 6, y: 2 },
          })
          .setOrigin(0.5, 1)
          .setDepth(CORE_LABEL_DEPTH);
        this.coreResLabel[side] = res;
        this.coreResText[side] = resText;
      } else if (this.coreResText[side] !== resText) {
        res.setText(resText);
        res.setColor(isMaxGold ? '#ef4444' : '#fde68a');
        res.setBackgroundColor(isMaxGold ? 'rgba(80, 10, 10, 0.88)' : 'rgba(12, 9, 7, 0.72)');
        this.coreResText[side] = resText;
      }
      res.setPosition(clampLabelX(x, res.width), hpBottom - (hp.height || 24) - 2);
    }
  }

  /**
   * VẼ 4 MINE — đọc THẲNG từ `world.mines`, không tự đặt toạ độ (xem chú thích `mineMarkers`).
   *
   * Gọi mỗi khung hình vì mine CẠN DẦN theo thời gian — người chơi phải thấy mỏ sắp hết để kịp mua
   * thêm nông dân đi mỏ khác.
   */
  private drawMines(world: ArenaWorld, camScrollX: number, viewW: number): void {
    const g = this.mineGfx;
    g.clear();
    const maxAmount = world.mines.reduce((m, x) => Math.max(m, x.amount), 1);
    /*
     * ⚠️⚠️ MỎ VẼ LẠI TỪ ĐẦU — BẢN CŨ TRÔNG NHƯ Ô DEBUG, KHÔNG PHẢI MỎ.
     *
     * Bản cũ vẽ `fillRect(80×52)` tô màu PHE SỞ HỮU (`SIDE_COLOR[m.owner ?? 'left']`) ⇒ 4 ô CHỮ NHẬT
     * XANH/VÀNG giữa sân. Người dùng nhìn ra ngay: *"có vẻ giống bản demo hơn là bản chơi được"*.
     *
     * Nay: mỏ là **đống đá có quặng** — hình dạng khác hẳn Nhà/ lính, màu TRUNG TÍNH (mỏ không thuộc
     * phe nào cho tới khi nông dân tới đào), và trữ lượng đọc bằng QUẶNG VÀNG + thanh mảnh bên dưới.
     *
     * 🔢 MỌI KÍCH THƯỚC ĐI QUA `arenaDist`: map đã co `ARENA_XSCALE` (xem `ARENA_WORLD` trong sim),
     * nên số của thang 2400 cũ (80×52) giờ là gần NỬA BỀ DÀY MỘT LAND ⇒ mỏ sẽ to hơn cả Nhà.
     */
    const W = arenaDist(84);
    const H = arenaDist(58);
    for (const m of mineMarkersOf(world.mines, maxAmount)) {
      if (!mineVisibleOf(m, camScrollX, viewW)) continue;
      const rock = m.empty ? 0x3f3f46 : 0x57534e;
      const rockEdge = m.empty ? 0x52525b : 0x2a2118;
      // thân mỏ: đống đá (ellipse) + chân đế tối để "đứng" trên sàn
      g.fillStyle(0x1c1917, 0.45);
      g.fillEllipse(m.x, m.y + H * 0.42, W * 1.15, H * 0.45);
      g.fillStyle(rock, 1);
      g.fillEllipse(m.x, m.y, W, H * 1.05);
      g.lineStyle(arenaDist(3), rockEdge, 1);
      g.strokeEllipse(m.x, m.y, W, H * 1.05);
      // QUẶNG: 3 cục vàng (mờ dần theo trữ lượng) — tín hiệu "còn đào được" đọc bằng MẮT
      const ore = m.empty ? 0x52525b : 0xfbbf24;
      const specks: Array<[number, number, number]> = [
        [-W * 0.22, -H * 0.08, W * 0.13],
        [W * 0.14, -H * 0.22, W * 0.1],
        [W * 0.2, H * 0.14, W * 0.11],
      ];
      for (const [dx, dy, r] of specks) {
        g.fillStyle(ore, m.empty ? 0.5 : 0.95);
        g.fillEllipse(m.x + dx, m.y + dy, r * 2, r * 1.5);
      }
      // thanh trữ lượng mảnh bên dưới: đọc "còn bao nhiêu" bằng số học, không phụ thuộc màu
      const barW = W * 0.95;
      const barY = m.y + H * 0.78;
      g.fillStyle(0x000000, 0.45);
      g.fillRect(m.x - barW / 2, barY, barW, arenaDist(7));
      g.fillStyle(m.empty ? 0x78716c : 0x22c55e, 0.95);
      g.fillRect(m.x - barW / 2, barY, barW * m.pct, arenaDist(7));
      if (m.empty) {
        // dấu X khi cạn — trạng thái "hết" không được phụ thuộc vào việc so màu
        g.lineStyle(arenaDist(4), 0xfca5a5, 0.95);
        g.lineBetween(m.x - W * 0.3, m.y - H * 0.28, m.x + W * 0.3, m.y + H * 0.28);
        g.lineBetween(m.x + W * 0.3, m.y - H * 0.28, m.x - W * 0.3, m.y + H * 0.28);
      }
    }
  }

  /**
   * VẼ CHỈ BÁO "ĐANG VÁC ĐỒ" TRÊN NÔNG DÂN — đọc `unit.carrying`.
   *
   * Yêu cầu người dùng: mắt phải đọc ra "con này đang vác đồ về". Quyết định quan trọng nằm ở
   * `carryingIndicator()`: trả `null` khi bao RỖNG — hiện chỉ báo cả lúc rỗng thì tín hiệu mất hết
   * ý nghĩa (mọi nông dân đều "đang vác").
   */
  private drawCarrying(world: ArenaWorld): void {
    const g = this.carryGfx;
    g.clear();
    for (const u of world.units) {
      const ind = carryIndicatorOf(u);
      if (!ind) continue;
      const col = SIDE_COLOR[sideOfTeam(u.team)];
      // túi vác: to dần theo độ đầy, đổi màu khi đầy bao
      const r = 7 + ind.pct * 5;
      const y = u.y - u.radius * 2.6;
      g.fillStyle(ind.full ? 0xfbbf24 : col.edge, 0.95);
      g.fillCircle(u.x, y, r);
      g.lineStyle(2, 0x1c1917, 0.8);
      g.strokeCircle(u.x, y, r);
      // vòng tiến trình quanh túi: đọc ra "sắp đầy chưa" mà không cần thanh riêng
      g.lineStyle(3, ind.full ? 0xfde68a : 0xffffff, 0.9);
      g.beginPath();
      g.arc(u.x, y, r + 4, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * ind.pct, false);
      g.strokePath();
    }
  }


  /**
   * MỘT KHUNG HÌNH: vẽ lại mine + chỉ báo vác đồ + **NHÀ (kèm QUẠT MÁU)** + **VỆT ĐẠN**.
   *
   * ⚠️ NỀN LỚN (`bg`/ `fieldImg`/ `tintGfx`) KHÔNG vẽ lại ở đây — chúng chỉ phụ thuộc hằng số thế giới
   * và ảnh đã nạp, vẽ lại mỗi khung hình là lãng phí; chúng chỉ vẽ lại khi `resize()`/ có ảnh mới.
   * ⚠️ NHƯNG `drawCores` THÌ PHẢI nằm trong vòng lặp này: nó vẽ QUẠT MÁU, mà máu đổi bất cứ lúc nào
   * (đòn đánh vào Nhà) ⇒ vẽ ở đường tĩnh (`drawWorld`) là **máu ĐỨNG IM** giữa trận. Vẽ lại 2 Nhà mỗi
   * khung hình rất rẻ (~6 hình × 2), và đây là cách DUY NHẤT giữ đúng thứ tự "bệ đá → quạt → thân Nhà"
   * trong cùng một `Graphics` (xem `drawCores`).
   *
   * ⚠️ `realDt` (giây của khung hình THẬT) dùng cho VỆT ĐẠN: đạn bay theo thời gian thực, không theo
   * `world.time` — sim tạm dừng mà đạn đang bay thì nó vẫn phải bay nốt (không đứng hình giữa không).
   */
  update(world: ArenaWorld, camScrollX: number, viewW: number, realDt = 1 / 60): void {
    if (this.disposed) return;
    this.drawMines(world, camScrollX, viewW);
    this.drawCarrying(world);
    this.drawCores(world);
    /*
     * NHÃN SỐ MÁU (+ TÀI NGUYÊN ĐỊCH) TRÊN ĐẦU NHÀ — xem `updateCoreLabels`. Gọi ở đây (mỗi khung hình)
     * vì máu Nhà đổi bất cứ lúc nào; bản thân hàm chỉ `setText` khi chuỗi ĐỔI nên chi phí ~0.
     */
    this.updateCoreLabels(world);
    this.drawShots(realDt);
  }

  /**
   * NẠP CÁC PHÁT BẮN MỚI TỪ SIM — scene gọi MỖI KHUNG HÌNH (xem `ArenaShot`).
   *
   * ⚠️ VÌ SAO KHÔNG ĐỂ TẦNG VẼ TỰ `world.drainShots()`: `update()` của lớp vẽ chỉ nhận `ArenaWorld`
   * (dữ liệu ĐỌC), còn `drainShots` là lệnh có TÁC DỤNG PHỤ (rỗng hoá hàng đợi). Để scene — nơi đã
   * gọi `drainCastFx` — làm việc đó, giữ đúng phân vai: sim phát, scene chuyển, lớp vẽ vẽ.
   *
   * ⚠️ Dữ liệu vào là toạ độ THẾ GIỚI; phần tử rác (NaN) bị bỏ để một sự kiện lỗi không vẽ ra vệt
   * chạy ngang cả sân.
   */
  addShots(shots: readonly ArenaShot[]): void {
    if (this.disposed || !shots.length) return;
    for (const s of shots) {
      if (!Number.isFinite(s?.fromX) || !Number.isFinite(s?.fromY) || !Number.isFinite(s?.toX) || !Number.isFinite(s?.toY)) continue;
      const size = Number.isFinite(s.size) ? Math.max(1, s.size) : 4;
      this.shots.push({ ...s, size, t: 0 });
    }
    // trần an toàn: sim phát dồn dập/ lỗi thì không phình vô hạn bộ nhớ + chi phí vẽ
    if (this.shots.length > SHOT_MAX) this.shots.splice(0, this.shots.length - SHOT_MAX);
  }

  /** XOÁ MỌI VỆT ĐẠN ĐANG BAY — gọi khi VÀO TRẬN MỚI và khi rời màn (không để vệt cũ nằm lại trên sân). */
  clearShots(): void {
    this.shots = [];
    this.shotGfx?.clear();
    this.shotUsed = 0;
    this.hideUnusedShots();
  }

  /**
   * MỘT SLOT SPRITE ĐẠN trong pool (tạo khi cần, giữ lại để tái dùng).
   *
   * ⚠️⚠️ CHỈ gọi sau khi đầu `drawShots` đã đặt `shotUsed = 0` — cùng lý do như `ProjectileLayer.take()`
   * (xem chú thích dài ở `render/projectiles.ts`): để cờ "slot đang bật" còn sót từ khung trước thì
   * slot đó bị bỏ qua, sprite cũ không được cập nhật vị trí nữa và **kẹt lại trên sân**.
   */
  private takeShot(): { img: Phaser.GameObjects.Image; trail: Phaser.GameObjects.Image } | null {
    if (this.shotUsed < this.shotPool.length) return this.shotPool[this.shotUsed];
    if (this.shotPool.length >= SHOT_MAX) return null;
    // texture khởi tạo chỉ để có hình hợp lệ; mỗi khung hình `setTexture` theo skin thật của viên đạn
    const seed = resolveShotSkin(undefined, 'thrown').texture;
    const trail = this.scene.add.image(0, 0, seed).setVisible(false).setAlpha(0.42).setDepth(SHOT_DEPTH - 1);
    const img = this.scene.add.image(0, 0, seed).setVisible(false).setDepth(SHOT_DEPTH);
    const slot = { img, trail };
    this.shotPool.push(slot);
    return slot;
  }

  /** ẨN phần pool không dùng khung này — quét `[shotUsed, pool.length)`, KHÔNG quét cả pool. */
  private hideUnusedShots(): void {
    for (let i = this.shotUsed; i < this.shotPool.length; i++) {
      this.shotPool[i].img.setVisible(false);
      this.shotPool[i].trail.setVisible(false);
    }
  }

  /**
   * VẼ VỆT ĐẠN — 2 pha cho mỗi phát bắn: (1) BAY (SPRITE theo skin + vệt) rồi (2) CHỚP ở đầu đích.
   *
   * ⚠️ ĐÂY LÀ HIỆU ỨNG HÌNH ẢNH THUẦN: sim đã trừ máu NGAY lúc bắn (xem `ArenaShot`), nên vệt đạn
   * KHÔNG được dùng để quyết định gì. Nó chỉ trả lời câu "vì sao địch vừa mất máu".
   *
   * ⚠️⚠️ PHA "BAY" NAY LÀ SPRITE CỦA **CHẾ ĐỘ ĐI ẢI**, KHÔNG PHẢI ĐOẠN THẲNG VẼ BẰNG `Graphics`.
   * Người dùng: *"Trong chế độ chơi arena, hình đường đạn đổi thành hình giống trong chế độ đi ải"*.
   * Bản cũ vẽ `lineStyle + lineTo` (một vệt thẳng màu phe) ⇒ nhìn là biết ngay hai chế độ khác nhau:
   * đi ải có dép/ lá rau/ quả pháo/ chai rượu, Arena chỉ có một vạch. Nay cả hai đi qua
   * `resolveShotSkin` (`render/projectiles.ts`) ⇒ cùng bảng hình, cùng cỡ, cùng màu.
   * `shotGfx` GIỮ LẠI nhưng chỉ còn vẽ PHA CHỚP ở đầu đích — chớp theo MÀU PHE nên vẫn đọc được
   * "ai vừa bắn ai" dù hình viên đạn giống nhau ở cả hai phe (đúng như chế độ đi ải).
   *
   * ⚠️ KHÔNG tạo đối tượng ĐIỂM của Phaser ở đây (xem chú thích dài trong `drawCores`): sprite được
   * tạo qua `scene.add.image` — đó là lời gọi phương thức trên scene, KHÔNG phải dùng namespace
   * `Phaser` dạng giá trị, nên `import Phaser from 'phaser'` vẫn bị elide và test node không chết.
   */
  private drawShots(realDt: number): void {
    const g = this.shotGfx;
    if (!g) return;
    g.clear();
    this.shotUsed = 0;
    if (!this.shots.length) {
      this.hideUnusedShots();
      return;
    }
    const alive: Array<ArenaShot & { t: number }> = [];
    for (const s of this.shots) {
      s.t += realDt;
      /*
       * ⚠️ THỜI GIAN BAY THEO TỪNG PHÁT (`s.flyTime`), KHÔNG dùng mãi hằng số `SHOT_FLY`: gạch của Nhà
       * bay 0,45s để mắt thấy cung, còn đạn thường 0,1s. Dùng chung một hằng số thì hoặc gạch bay quá
       * nhanh (chỉ thấy một chớp), hoặc đạn thường bay lê thê làm cảm giác bắn bị "trễ".
       */
      const fly = s.flyTime && s.flyTime > 0 ? s.flyTime : SHOT_FLY;
      if (s.t >= fly + SHOT_FLASH) continue; // hết vòng đời ⇒ bỏ (không vẽ nữa)
      if (s.t < fly) {
        const slot = this.takeShot();
        if (slot) {
          this.drawFlyingShot(slot, s, fly);
          this.shotUsed++;
        }
      } else {
        this.drawShotImpact(s);
      }
      alive.push(s);
    }
    this.shots = alive;
    this.hideUnusedShots();
  }

  /** (1) PHA BAY: đặt sprite đầu đạn + vệt bay theo skin của viên đạn. */
  private drawFlyingShot(
    slot: { img: Phaser.GameObjects.Image; trail: Phaser.GameObjects.Image },
    s: ArenaShot & { t: number },
    fly: number,
  ): void {
    const k = Math.min(1, s.t / fly); // 0 → 1 dọc đường bay
    const hx = s.fromX + (s.toX - s.fromX) * k;
    /*
     * ⚠️ CUNG BAY CỦA GẠCH (Nhà chính): nâng sprite theo `sin(π·k)` — 0 ở hai đầu, cao nhất ở giữa.
     * Dùng dấu TRỪ vì trục Y màn hình hướng xuống; nhân 0,75 để đỉnh cung không lệch quá xa vị trí va
     * chạm thật (nếu nâng đủ 100% thì mắt thấy gạch "bay trên đầu quái" mà máu lại mất ở dưới chân).
     */
    const arcLift = s.arcHeight ? Math.sin(Math.PI * k) * s.arcHeight * 0.75 : 0;
    const hy = s.fromY + (s.toY - s.fromY) * k - arcLift;
    const angle = Math.atan2(s.toY - s.fromY, s.toX - s.fromX) + (s.arcHeight ? k * Math.PI * 2.2 : 0);
    const skin = resolveShotSkin(s.skin, s.kind ?? 'thrown');
    const dist = Math.hypot(s.toX - s.fromX, s.toY - s.fromY);
    /*
     * ⚠️⚠️ NHÂN `ARENA_UNIT_SCALE` CHO CẢ ĐẠN LẪN VỆT — ĐỌC TRƯỚC KHI BỎ.
     *
     * `SKIN_SIZE`/ `skin.dw`/`skin.dh` là cỡ của chế độ đi ải, đo theo NHÂN VẬT CAO 104 ĐƠN VỊ.
     * Arena vẽ nhân vật ở `ARENA_UNIT_SCALE` = 0,6 (xem `arena-battle-scene.ts`: `setUnitScale`) ⇒
     * nếu vẽ đạn đúng cỡ đi ải thì so với nhân vật Arena, đạn to gấp ~1,67 lần — đúng lỗi "đạn to quá"
     * mà người dùng đã từng báo ở chế độ đi ải, chỉ khác là lần này nó thành ra ở Arena.
     * Nhân theo đúng tỉ lệ nhân vật ⇒ TỈ LỆ ĐẠN/ NGƯỜI giống hệt chế độ đi ải (đó mới là "hình giống").
     *
     * ⚠️ Vì sao KHÔNG sửa `SKIN_SIZE` cho nhỏ đi: bảng hình là DÙNG CHUNG, sửa ở đó là bóp méo luôn
     * chế độ đi ải (đang đúng). Hệ số theo từng chế độ phải nằm ở TẦNG VẼ của chế độ đó.
     */
    const scale = ARENA_UNIT_SCALE;
    // VỆT dài theo QUÃNG BAY (Arena biết trước quãng đường), kẹp lại để phát bắn ngắn không thành cục
    const trailLen = Math.max(SHOT_TRAIL_MIN, Math.min(SHOT_TRAIL_MAX, dist * 0.35)) * scale;
    slot.img
      .setTexture(skin.texture)
      .setPosition(hx, hy)
      .setRotation(angle)
      .setTint(skin.fallback)
      .setVisible(true)
      .setDisplaySize(skin.dw * scale, skin.dh * scale);
    /*
     * ⚠️ GẠCH NÉM CUNG KHÔNG CÓ VỆT BAY: vệt ngang nằm ở độ cao mặt đất trong khi viên gạch đang ở
     * đỉnh cung ⇒ nhìn như hai vật thể rời nhau. Ẩn hẳn, chỉ giữ hình gạch + xoay (đúng cách chế độ
     * đi ải xử lý chai rượu).
     */
    if (s.arcHeight) {
      slot.trail.setVisible(false);
      return;
    }
    slot.trail
      .setTexture(skin.texture)
      .setPosition(hx - Math.cos(angle) * trailLen * 0.6, hy - Math.sin(angle) * trailLen * 0.6)
      .setRotation(angle)
      .setTint(skin.fallback)
      .setAlpha(0.42)
      .setVisible(true)
      .setDisplaySize(trailLen, skin.dh * 0.85 * scale);
  }

  /** (2) PHA TỚI NƠI: tia chớp loe ra rồi tắt ở ĐÚNG đầu đích (nơi sim đã trừ máu) — màu PHE. */
  private drawShotImpact(s: ArenaShot & { t: number }): void {
    const g = this.shotGfx;
    const k = (s.t - SHOT_FLY) / SHOT_FLASH; // 0 → 1
    const col = SIDE_COLOR[s.side].edge;
    const headR = Math.max(2, s.size * 0.5);
    g.lineStyle(Math.max(2, s.size * 0.4), col, 0.9 * (1 - k));
    g.strokeCircle(s.toX, s.toY, Math.max(3, s.size * (0.6 + 1.8 * k)));
    g.fillStyle(0xffffff, 0.85 * (1 - k));
    g.fillCircle(s.toX, s.toY, Math.max(1.5, headR * (1 - k)));
  }


  /**
   * GỌI KHI CỬA SỔ ĐỔI KÍCH THƯỚC.
   * Chỉ vẽ lại nền (hằng số) — camera tự lo phần kẹp biên (xem `ArenaCamera.resize`).
   */
  resize(): void {
    if (this.disposed) return;
    this.drawWorld();
  }

  /** Dọn sạch GameObject khi rời màn — tránh rò rỉ sprite qua nhiều trận. */
  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.bg.destroy();
    this.tintGfx.destroy();
    this.coreGfx.destroy();
    this.mineGfx.destroy();
    this.carryGfx.destroy();
    this.shotGfx.destroy();
    this.shots = [];
    // SPRITE ĐẠN: huỷ cả pool (không huỷ là mỗi lần vào lại Arena rò thêm tối đa 64×2 sprite)
    for (const s of this.shotPool) {
      s.img.destroy();
      s.trail.destroy();
    }
    this.shotPool = [];
    this.shotUsed = 0;
    // ảnh vẽ thật: dọn cùng lượt, nếu không thì mỗi lần vào lại sân là rò thêm một bộ ảnh
    this.fieldImg?.destroy();
    for (const d of this.decorImgs) d.destroy();
    for (const h of Object.values(this.houseImgs)) h?.destroy();
    // NHÃN SỐ MÁU/ TÀI NGUYÊN trên đầu Nhà — cùng luật: mỗi lần vào lại Arena là một bộ `Text` mới
    for (const l of Object.values(this.coreHpLabel)) l?.destroy();
    for (const l of Object.values(this.coreResLabel)) l?.destroy();
    this.coreHpLabel = {};
    this.coreResLabel = {};
    this.coreHpText = {};
    this.coreResText = {};
    this.decorImgs = [];
    this.houseImgs = {};
  }
}

// ════════════════════════════════════════════════════════════════════════════
// 4. HÀM DỰNG + TIỆN ÍCH CHO SCENE/ HUD
// ════════════════════════════════════════════════════════════════════════════

/**
 * DỰNG TRỌN BỘ TẦNG NHÌN CỦA ARENA: lớp vẽ thế giới + camera cuộn.
 *
 * Vì sao gom vào một hàm: `ArenaBattleScene` không nên biết thứ tự khởi tạo, cũng không nên biết cỡ
 * vùng nhìn mặc định. Gom vào đây thì scene chỉ còn một dòng.
 *
 * ⚠️ `ARENA_CAMERA_VIEW` là cỡ THIẾT KẾ (1000×700), KHÔNG phải cỡ cửa sổ thật. Cỡ thật do scene
 * truyền vào qua `resize()`. Truyền cỡ cửa sổ thật vào đây là mắc đúng bẫy #1 của `arena-camera.ts`
 * (camera lệch ⇒ mọi cú bấm sai toạ độ).
 */
export function createArenaBattleVisuals(
  scene: BattleScene,
  worldW: number,
  worldH: number,
): { view: ArenaBattleView; camera: ArenaCamera } {
  const view = new ArenaBattleView(scene);
  const camera = new ArenaCamera(
    scene as CameraScene,
    worldW,
    worldH,
    ARENA_CAMERA_VIEW.w,
    ARENA_CAMERA_VIEW.h,
  );
  return { view, camera };
}

/*
 * `arenaLandOptions()` ĐÃ BỊ XOÁ CÙNG "3 LAND" — LUẬT ĐỔI, KHÔNG PHẢI "DỌN CHO GỌN".
 * Hàm đó trả `{ land, label }` cho 3 nút chọn land trên HUD. Luật mới không còn land: người chơi thả
 * quân ở TOẠ ĐỘ TỰ CHỌN (xem `sim/arena/deploy-pos.ts`), nên không còn gì để chọn. Giữ nó lại là giữ
 * một API trỏ vào khái niệm không tồn tại — và `ARENA_LAND_NAME`/ kiểu `Land` cũng đã bị xoá khỏi
 * `data/arena.ts`/ `sim/arena/types.ts` nên nó không còn biên dịch được.
 */

/**
 * ĐỊNH DẠNG TÀI NGUYÊN ĐỂ HIỂN THỊ — CHỈ ĐỊNH DẠNG, KHÔNG LƯU.
 *
 * Vì sao không cache ở tầng này: tài nguyên đổi mỗi khi nông dân giao hàng hoặc người chơi summon.
 * Giữ bản sao ở tầng vẽ là mở đường cho "HUD hiện 500 mà ví thật 300" — đúng loại lỗi hai nguồn sự
 * thật mà cả dự án này đang tránh. HUD phải đọc `world.resource` mỗi lần vẽ.
 */
export function formatArenaResource(amount: number): string {
  return Math.floor(amount).toLocaleString('vi-VN');
}

/**
 * MÔ TẢ NHỊP THẢ QUÂN ĐỂ HIỆN TRÊN HUD, SINH TỪ SỐ THẬT CỦA SIM.
 *
 * ⚠️ KHÔNG hard-code "20 giây"/"60 giây" ở đây. Người dùng đã chốt các con số đó và có test khoá
 * `ARENA_TICK`; nhưng nếu HUD tự viết lại chữ thì khi ai đó đổi `ARENA_TICK` (có lý do chính đáng),
 * HUD sẽ hiện số CŨ ⇒ người chơi bị nói sai luật. Sinh từ hằng số là cách duy nhất giữ chúng khớp.
 */
export function arenaCadenceText(): string {
  return [
    t(ARENA_TEXT.waveEvery, `Minions every ${ARENA_TICK.minionEvery}s`),
    t(ARENA_TEXT.bossEvery, `Elise every ${ARENA_TICK.bossEvery}s`),
    t(ARENA_TEXT.titanEvery, `Titan every ${ARENA_TICK.titanEvery}s`),
  ].join(' · ');
}

/**
 * VỊ TRÍ X CỦA NHÀ 2 PHE — suy từ `ARENA_CORE`, KHÔNG hard-code 150/2250.
 * Scene/ HUD dùng để quyết định "Nhà nào đang trong tầm nhìn" và để đặt nút.
 */
/**
 * HỆ SỐ CỠ NHÂN VẬT/ QUÁI CỦA ARENA (1 = cỡ gốc của màn vượt ải).
 *
 * ⚠️ VÌ SAO < 1 — YÊU CẦU NGƯỜI DÙNG: *"nhân vật ở Arena cũng nhỏ tương xứng đảm bảo nhiều tướng,
 * nhiều quái, nhiều nông dân cũng không bị kẹt hay vướng"*.
 *
 * 🔢 VÌ SAO 0,6: sau khi co map về 1000×600, 3 land cách nhau 180 và nửa bề dày land là
 * `ARENA_LAND_HALF_COLLIDE` = 62 ⇒ cả dải chỉ cao 124. Nhân vật cỡ gốc (`TARGET_CHAR_HEIGHT` = 104)
 * gần bằng CẢ dải ⇒ 2–3 đơn vị cùng land là chồng hình lên nhau và tràn sang land bên cạnh.
 * `0,6 × 104 ≈ 62` = đúng nửa bề dày dải ⇒ nhiều đơn vị vẫn đọc được, mà vẫn thấy rõ mặt nhân vật.
 *
 * ⚠️ KHÔNG sửa `TARGET_CHAR_HEIGHT` trong `art/character.ts`: hằng số đó dùng chung với trận 10-wave
 * đang chạy production. Hệ số này chỉ áp cho `ArenaBattleScene`.
 */
export const ARENA_UNIT_SCALE = 0.6;

export function arenaCoreX(side: ArenaSide): number {
  return side === 'left' ? ARENA_CORE.leftX : ARENA_CORE.rightX;
}
